import { Component, OnInit, Input, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BrokerageManagerService } from '../../shared/providers/brokerage-manager.service';
import { BehaviorSubject, catchError, distinctUntilChanged, Observable, of, Subject, switchMap, tap } from 'rxjs';
import {
  SavePropertyInputModel,
  SavePropertyBrokerInputModel,
  PropertyHighlightsListOutputModel,
  PropertyDocument,
  PropertyFile,
  Tenant,
  EditPropertyDeatilsModel,
  DocumentCategoryModel,
  PropertySalesInputModel,
  numberOfUnitsValidator,
  spaceOnlyValidator,
  BrokerSelecttionModel,
  IGuarantorList,
  minimumYearValidator,
  minimumDateValidator,
  minValidator,
  maxValidator,
  vimeoUrlValidator,
  defaultValidator,
  maxDateValidator,
  PropertyLeasingHistoryInputModel,
  IDuplicates,
  PropertySaleHistoryModel,
  ImageDetailModel
} from '../../shared/models/SavePropertyInputModel';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { FileUploadService } from '../../shared/providers/fileupload.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ValidationService } from '../../shared/providers/validation.service';
import { CommonService } from '../../shared/providers/common.service';
import { RestService } from '../../shared/providers/rest.service';
import { ToastService } from '../../shared/providers/toast.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { IStatesList } from '../../shared/models/StatesListOutputModel';
import { ICities } from '../../shared/models/CitiesListOutputModel';
import { PropRemainingTermPipe } from '../../shared/pipes/prop-remaining-term.pipe';
import { FormGroup, FormControl, Validators, DefaultValueAccessor } from '@angular/forms';
import { IFileUpload, IPropertyFileUpload } from '../../shared/models/fileupload';

declare module 'googlemaps';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { LoaderService } from '../../shared/providers/loader.service';
//import { ResultOutputModel } from '../shared/models/resultOutputModel';
import { IBroker } from '../../shared/models/BrokerListOutputModel';
import { IBrokerageList } from '../../shared/models/BrokerageListOutputModel';
import { DataTableDirective } from 'angular-datatables';
import { IPropertyRentTermModel } from '../../shared/models/PropertyRentTermModel';
import { RentTermTableComponent } from '../../property/rent-term-table/rent-term-table.component';
import { IGuarantorRating } from '../../shared/models/GuarantorModels';
import { RatingAgency, PropertyStatus } from '../../shared/enum/enum';
import { SharedService } from '../../shared/providers/shared.service';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { IBrokerageBrokerInput } from '../../shared/models/BrokerageBrokerInputModel';
import { IBrokergaCreationalResponseModel } from '../../shared/models/BrokerageCreationResponseModel';
import { AuthService } from '../../shared/auth/auth.service';

@Component({
  selector: 'app-add-new-property',
  templateUrl: './add-new-property.component.html',
  styleUrls: ['./add-new-property.component.css']
})

export class AddMyportfolioPropertyComponent implements OnInit {
  brokers: BrokerSelecttionModel[];
  //#region View fields
  @ViewChild(RentTermTableComponent) child: RentTermTableComponent;
  @ViewChild('propDoc', { static: true }) propDoc: ElementRef;
  @ViewChild('propImage', { static: true }) propImage: ElementRef;
  @ViewChild('gmap', { static: true }) gmapElement: any;
  @ViewChild('PropertyForSelection', { static: true }) propertyForSelection: TemplateRef<any>;
  @ViewChild('PropertyForConfirmation', { static: true }) propertyForConfirmation: TemplateRef<any>;
  dtOptions = {};
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  table: DataTableDirective;
  map: google.maps.Map;
  autoComplete: google.maps.places.Autocomplete;
  marker: google.maps.Marker;
  _propertyId: string;
  modalRef: BsModalRef;
  modalRemoveBrockerRef: BsModalRef;
  modalRefPropertyForSelection: BsModalRef;
  modalRefPropertyForConfirmation: BsModalRef;
  model: EditPropertyDeatilsModel;
  keyCode: number[];
  isInEditMode = false; // Spcifies that whether the form is in edit mode
  isSubmitted = false;
  isSPR = true;
  isMoody = false;
  inputBrokers=[];
  disablePropertyStatus = true;
  isFitch = false;
  UserRoleId: number;
  isFranchise = true;
  isCorporate = false;
  AssumableList: ILookUp[];
  PrepayList: ILookUp[];
  AmortizationFieldList: ILookUp[];
  sprRatingList: ILookUp[];
  moodysRatingList: ILookUp[];
  fitchRatingList: ILookUp[];
  statesList: IStatesList[];
  guarantorList: IGuarantorList[];
  citiesList: ICities[];
  brokersList: IBroker[];
  users: any[];
  brokerageList: IBrokerageList[];
  allBrokerage: IBrokerageList[];
  propertyTypesList=[];
  subCategoriesList=[];
  characteristicList= [];
  propertyForList: ILookUp[];
  propertyStatusList: ILookUp[];
  leaseStructureList: ILookUp[];
  ownershipList: ILookUp[];
  docCategories: ILookUp[];
  propertyImages: PropertyFile[] = [];
  propertyDocuments: PropertyDocument[] = [];
  tenants: Tenant[];
  group: any[];
  tenant: Tenant;
  rating = '1';
  userRole: number = 0;
  today = new Date();
  uploadedFiles: IPropertyFileUpload[] = [];
  uploadedPropertyDocuments: IPropertyFileUpload[] = [];
  investmentHighlights: PropertyHighlightsListOutputModel[] = [];
  selectedBroker: number = null;
  dataService: [];/*CompleterData;*/
  isPropertyForSale = false;
  randomID = -10001;
  stateName: string;
  minRenovatedYear: number;
  isComp = false;
  isArchive = false;
  documentCategoryList: DocumentCategoryModel[] = [];
  imageDetailList: ImageDetailModel[] = [];
  loggedUserDetails: any;
  propertyFor = 'B+E Listing';
  UserGuid: string;
  defaultBrokerSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  //defaultBrokerText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select'
  //};
  removedImageIds: number[] = [];
  removedDocIds: number[] = [];
  rentTerms = {} as IPropertyRentTermModel;
  IsRentTableVisible = false as boolean;
  IsPageLoaded = true as boolean;
  InitialLoad = true as boolean;
  retnTermAutoCalcValue = true as boolean;
  dataEntryPropertyStatusId = 0 as number;
  isPortfolio = false;
  ownershipTypelist= [];
  leaseStructureMultiList= [];
  propertyStatusList_All: ILookUp[];
  modalSuggestedPropertyRef: BsModalRef;
  propertyForDisabled = false;
  capratetext: string = 'Cap Rate';
  propCharcObj: number[]
  disableCapRate: boolean;

  private isMarkerEventSubscribed = false;

  private _contactForm: FormGroup;

  public get contactForm(): FormGroup {
    return this._contactForm;
  }

  fullDateYearOfBuilt: Date;

  contactTypes = [
    { Id: 551, Name: 'Primary' },
    { Id: 552, Name: 'Secondary' },
    { Id: 553, Name: 'Others' }
  ];

  currentBrokerLicense: SavePropertyBrokerInputModel;

  isBrokerFormEditMode = false;

  viewSoldDetailsLink = false;

  propForm: FormGroup;

  fileUploadCount = 0;

  currentSalesDetails: PropertySalesInputModel;
  //#endregion
  prevPage = "My Properties";
  prevPageRouteLink = "portfolio-propertyListing";
  brockerIndex: number;
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };
  //defaultTypeText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select'
  //};
  leaseHistory = [] as PropertyLeasingHistoryInputModel[];
  duplicates = {} as IDuplicates;
  @ViewChild('Duplicate', { static: true }) DuplicateTemplate: TemplateRef<any>;
  modalRefDuplicates: BsModalRef;
  FileUpload = {} as IFileUpload;
  saleHistory = [] as PropertySalesInputModel[];
  UploadIndex = 0 as number;
  docUploadIndex = new BehaviorSubject<number>(0);
  @ViewChild('addresstext', { static: true }) addresstext: any;
  isPlacesApi = false as boolean;
  PlacesLat: number;
  PlacesLong: number;
  disableAddEditHistoryButton = false as boolean;
  propertyStatus = PropertyStatus
  tenantTypeList= [];
  portfolioSelectedProperties = [] as any[];
  IsmyPortfolio: boolean;
  selectedPortfolioName: string;
  isInitialLoad: boolean = true
  IsMerge = false;
  opentab: number;

  constructor(private _ChangeDetectorRef: ChangeDetectorRef, private http: HttpClient, private _userManagerService: UserManagerService, public authService: AuthenticationService, private modalService: BsModalService, private _restService: RestService,
    private _propertyManagementService: PropertyManagementService, private _fileUploadService: FileUploadService,
    private router: Router, public validationService: ValidationService, private activatedRoute: ActivatedRoute,
    private _toastService: ToastService, private _commonService: CommonService, /*private completerService: CompleterService,*/
    protected loaderService: LoaderService, private _brokerageManagerService: BrokerageManagerService, private _auth0: AuthService, private cdRef: ChangeDetectorRef, private _sharedService: SharedService,
    private _propertyListingService: PropertyListingService) {

    if (!authService.isLoggedIn) {
      this.router.navigate(['/']);
    }
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        this._propertyId = params['id'];
        this.isInEditMode = true;
      }
      else {
        this.isInEditMode = false;
      }
    });
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let routeName = params['prevroute'];
      let routeLink = params['link'];
      if (routeName !== null && routeName !== undefined) {
        this.prevPage = routeName;
        this.prevPageRouteLink = routeLink;
      }
      if (params['merge']) {
        this.IsMerge = params['merge'];
      }
      if (params['UserGuid'] != null && params['UserGuid'] != '' && params['UserGuid'] != undefined) {
        this.UserGuid = params['UserGuid'];
      }
      if (params['isPortfolio']) {
        this.isPortfolio = JSON.parse(params['isPortfolio']);
      }
      if (params['IsmyPortfolio']) {
        this.IsmyPortfolio = JSON.parse(params['IsmyPortfolio']);
      }
      if (params['SelectedPortfolioName']) {
        this.selectedPortfolioName = JSON.parse(params['SelectedPortfolioName']);
      }
    });

    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/property/tenants/', 'TenantName', 'TenantName');
    //remoteDataProvider.urlFormater(x => {
    //  return encodeURI(_restService.getBaseUrl + '/property/tenants?searchText=' + encodeURIComponent(x));
    //});
    //this.dataService = remoteDataProvider;
    this.loadItems();
  }

  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  loading = false;

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      tap(() => this.loading = true),
      switchMap(term => this.getItems(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getItems(term: any = null): Observable<any[]> {
    return this._propertyManagementService.getTenantList(term);
  }

  get getDocUploadIndex() {
    return this.docUploadIndex.asObservable();
  }
  timd = null;
  disableGuarantorName: boolean = true;
  ngOnInit() {
    if (this.prevPage != null && this.prevPage != undefined) {

    }
    this.timd = new Date() + '-' + this.validationService.utcify(new Date());
    this.UserGuid = this.UserGuid != '' && this.UserGuid != null ? this.UserGuid : '0000';
    this.loaderService.display(true);
    this.resetModel(); // Resets the model on initialization
    this.loggedUserDetails = this.authService.user;
    this.model.PropertyForId = 602;
    this.model.LoginUserId = this.loggedUserDetails.Id;
    this.model.IsNewGuarantor = false;
    this.disableGuarantorName = true;
    this.model.IsNewTenant = false;
    this.model.PrePay = null;
    this.model.Assumable = null;
    this.model.UserGuid = this.UserGuid;
    this.model.Amortization = null;

    //#region Init Dropdown fills
    this.minRenovatedYear = this.model.YearBuilt;

    this.authService.isLoggedIn.subscribe(response => {
      if (response) {
        this.loggedUserDetails = this.authService.user;
        this.model.LoginUserId = this.loggedUserDetails.Id;
        this.userRole = this.loggedUserDetails.RoleId;

      }
    });
    this._propertyManagementService.getSAndPRatingList().subscribe(response => {
      this.sprRatingList = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    this._propertyManagementService.getMoodysRatingList().subscribe(response => {
      this.moodysRatingList = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    this._propertyManagementService.getFitchRatingList().subscribe(response => {
      this.fitchRatingList = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    this._commonService.getStateList().subscribe(response => {
      this.statesList = response.map(o => {
        return {
          Id: o.Id, Name: o.StateName
        };
      });
    });

    this._commonService.getLookupsByTypeId(64).subscribe(response => {
      this.AmortizationFieldList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
    });

    const arr = [
      { id: 1, description: 'Yes', lookupvalue: true },
      { id: 2, description: 'No', lookupvalue: false },
    ];
    this.AssumableList = arr.map(o => {
      return { id: o.id, description: o.description, lookupValue: o.lookupvalue }
    });
    this.PrepayList = arr.map(o => {
      return { id: o.id, description: o.description, lookupValue: o.lookupvalue }
    });

    let myportfolioid = this.isInEditMode ? this._propertyId : "0";
    this._commonService.getPortfolioPropertyStatus(myportfolioid, 'Portfolio').subscribe(response => {
      this.propertyStatusList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
      if (!this.isInEditMode) {
        this.model.PropertyStatusId = 6906;
      }
    });

    this._propertyManagementService.getFileCategories(6808).subscribe(response => {
      this.docCategories = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    this._commonService.getTypeList().subscribe(response => {
      this.propertyTypesList = response.map(o => {
        return { id: o.Id, name: o.Type };
      });
    });

    // Loads the lease structure list
    this._commonService.getLookupsByTypeId(12).subscribe(response => {
      if (this.isPortfolio) {
        this.leaseStructureMultiList = response.map(o => {
          return { id: o.Id, name: o.Description };
        });
      }
      else {
        this.leaseStructureList = response.map(o => {
          return {
            id: o.Id, description: o.Description
          };
        });
      }
    });

    // Loads the ownership list
    this._commonService.getLookupsByTypeId(13).subscribe(response => {
      if (this.isPortfolio) {
        this.ownershipTypelist = response.map(o => {
          return { id: o.Id, name: o.Description };
        });
      }
      else {
        this.ownershipList = response.map(o => {
          return {
            id: o.Id, description: o.Description
          };
        });
      }
    });

    //#endregion
    this.propForm = new FormGroup({
      'txtTenantTradeName': new FormControl(this.model.TenantTradeName, [
      ]),

      'txtTenantName': new FormControl(this.model.TenantName, [

      ]),

      'rdFranchisee': new FormControl(this.model.IsFranchisee),
      'rdCoorporate': new FormControl(),
      'radio1': new FormControl(),
      'lstSandP': new FormControl(this.model.SPRatingId),
      'lstMoodyRating': new FormControl(this.model.MoodyRatingId),
      'fitchRating': new FormControl(this.model.FitchRatingId),
      'txtNumberOfUnits': new FormControl(this.model.NoOfUnits, [
        this.isPropertyForSale && this.model.PropertyStatusId != 6906 ? Validators.min(1) : defaultValidator,
      ]),
      'txtGuarantor': new FormControl(this.model.Guarantor, [
        spaceOnlyValidator
      ]),
      'drpGuarantor': new FormControl(this.model.GuarantorId, []),
      'txtAddress': new FormControl(this.model.Address, [
        Validators.required,
        spaceOnlyValidator
      ]),
      'lstState': new FormControl(this.model.StateId, [
        Validators.required
      ]),
      'lstCity': new FormControl(this.model.CityId, [
        Validators.required
      ]),

      'txtZip': new FormControl(this.model.Zip, [
        Validators.required
      ]),
      'lat': new FormControl(this.model.Latitude),
      'lon': new FormControl(this.model.Longitude),
      'chkIsFeatured': new FormControl(this.model.IsFeatured),
      'txtYearBuilt': new FormControl(this.model.YearBuilt, [
        Validators.min(1850)
      ]),
      'chkUnpriced': new FormControl(this.model.Unpriced),
      'txtRenovated': new FormControl(this.model.Renovated, [
        //this.isPropertyForSale ? Validators.required : defaultValidator,
        this.isPropertyForSale ? Validators.max(this.today.getFullYear()) : defaultValidator,
        Validators.minLength(4),
        this.isPropertyForSale ? minValidator(() => this.builtYear) : defaultValidator


      ]),
      'txtUnpricedText': new FormControl({ value: this.model.UnpricedText, disabled: true }),
      'txtCapRateText': new FormControl({ value: this.model.UnpricedText, disabled: true }),
      'lstSubcatgeories': new FormControl(this.model.PropertyTypeSubcategoryList, [
        this.model.PropertyStatusId == 6906 ? Validators.required : defaultValidator
      ]),
      'txtBuildingSF': new FormControl(this.model.BuildingSize, [
        Validators.required,
        Validators.min(1)
      ]),
      'txtland': new FormControl(this.model.Land, [Validators.min(0.001),
      this.model.PropertyStatusId == 6906 ? Validators.required : defaultValidator
      ]),

      'lstPropertyStatus': new FormControl(this.model.PropertyStatusId, [
      ]),
      'lstPropertyType': new FormControl(this.model.PropertyTypeList, [
        Validators.required
      ]),
      'lstPrepay': new FormControl(this.model.PrePay, [
      ]),
      'lstAssumable': new FormControl(this.model.Assumable, [
      ]),
      'lstAmortization': new FormControl(this.model.Amortization, [
      ]),
      'txtNOI': new FormControl(this.model.NOI, [
        Validators.required,
        Validators.min(0)
      ]),
      'txtPSF': new FormControl({ value: this.model.LeasePricePSF, disabled: true }, [
        this.isPropertyForSale && this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator,
        this.isPropertyForSale && this.model.PropertyStatusId != 6906 ? Validators.min(0) : defaultValidator
      ]),
      'txtCommencement': new FormControl(this.model.LeaseCommencementDate, [
        Validators.required,
        //maxDateValidator(() => Date.now()),
        minimumYearValidator(() => this.builtYear)
      ]),
      'txtExpiration': new FormControl(this.model.LeaseExpiration, [
        Validators.required,
        Validators.min(this.model.YearBuilt),
        minimumDateValidator(() => this.model.LeaseCommencementDate)
      ]),
      'txtOriginal': new FormControl({ value: this.model.OriginalLeaseTerm, disabled: true }),
      'txtOriginalHdn': new FormControl(this.model.OriginalLeaseTerm),
      'txtEscalationPercentage': new FormControl(this.model.RentEscalationPercentage, [
        Validators.min(0),
        Validators.max(100)
      ]),
      'txtEscalationYrs': new FormControl(this.model.RentEscalationPeriod, [
        Validators.min(0)
      ]),
      'txtOptionNumber': new FormControl(this.model.OptionNumber),
      'txtOptionLength': new FormControl(this.model.OptionLength, [
        Validators.min(0)
      ]),
      'chkNewTenantInfo': new FormControl(this.model.IsNewTenant),
      'chkGurantorInfo': new FormControl(this.model.IsNewGuarantor),
      'lstLeaseStructure': new FormControl(this.model.LeaseStructureId, [
        Validators.required
      ]),
      'lstOwnershipType': new FormControl(this.model.OwnershipTypeId, [
        Validators.required
      ]),
      'txtAskingPrice': new FormControl(this.model.Price, [
        this.model.PropertyStatusId != 6906 || !this.model.Unpriced ? Validators.required : defaultValidator
      ]),
      'txtPricePSF': new FormControl(this.model.PricePSF),
      'txtCapRate': new FormControl(this.model.CapRate, [
        Validators.min(0),
        Validators.max(100)
      ]),
      'txtTenantNameFreeText': new FormControl(this.model.TenantNameText, [

      ]),
      'txtGuarantorNameText': new FormControl(this.model.GuarantorName, [

      ]),
      'chkOfferMemoReqApproval': new FormControl(this.model.OfferMemoReqApproval),
      'chkDueDiligenceReqApproval': new FormControl(this.model.DueDiligenceReqApproval),
      'chkConfidentialityAgreement': new FormControl(this.model.ConfidentialityAgreement),
      'chkDDConfidentialityAgreement': new FormControl(this.model.DDConfidentialityAgreement),
      /// portfolio start //
      'txtRemainingLeaseTermYear': new FormControl(this.model.PortfolioRemainingLeaseTermYear),
      'txtRemainingLeaseTermMonth': new FormControl(this.model.PortfolioRemainingLeaseTermMonth),
      'txtOriginalLeaseTerm': new FormControl(this.model.PortfolioOriginalLeaseTerm),
      'chkAutoCalcPortfolioType': new FormControl(this.model.AutoCalcPortfolioType),
      'chkAutoCalcOwnershipType': new FormControl(this.model.AutoCalcOwnershipType),
      'chkAutoCalcRent': new FormControl(this.model.AutoCalcRent),
      'chkAutoCalcOriginalLeaseTerm': new FormControl(this.model.AutoCalcOriginalLeaseTerm),
      'chkAutoCalcCommencement': new FormControl(this.model.AutoCalcCommencement),
      'chkAutoCalcLeaseExpiration': new FormControl(this.model.AutoCalcLeaseExpiration),
      'chkAutoCalcRemainingLeaseTerm': new FormControl(this.model.AutoCalcRemainingLeaseTerm),
      'chkAutoCalcLeaseType': new FormControl(this.model.AutoCalcLeaseType),
      'chkZeroCashflow': new FormControl(this.model.OnlyZCF),
      'chkAutoCalcRentalIncrease': new FormControl(this.model.AutoCalcRentalIncrease),
      'chkAutoCalcOptionNumber': new FormControl(this.model.AutoCalcOptionNumber),
      'chkAutoCalcOptionLength': new FormControl(this.model.AutoCalcOptionLength),
      'chkAutoCalcNumberOfLocations': new FormControl(this.model.AutoCalcNumberOfLocations),
      'chkAutoCalcNumberOfProperties': new FormControl(this.model.AutoCalcNumberOfProperties),
      'chkAutoCalcPortfolioSubcategory': new FormControl(this.model.AutoCalcPortfolioSubcategory),
      'lstTenantType': new FormControl(this.model.TenantTypeId),
      'chkAutoCalcTenantType': new FormControl(this.model.AutoCalcTenantType),
      'chkAutoCalcCapRate': new FormControl(this.model.AutoCalcCapRate),
      'chkAutoCalcLand': new FormControl(this.model.AutoCalcLand),
      'chkAutoCalcBuildingSize': new FormControl(this.model.AutoCalcBuildingSize),
      'chkIsOfferOnAllProperties': new FormControl(this.model.IsOfferOnAllProperties),
      'txtAcquisitionPrice': new FormControl(this.model.AcquisitionPrice),
      'txtAcquisitionCapRate': new FormControl(this.model.AcquisitionCapRate, [Validators.min(0),
      Validators.max(100)]),
      'txtLoanAmount': new FormControl(this.model.LoanAmount),
      'txtInterestRate': new FormControl(this.model.InterestRate, [
        Validators.min(0),
        Validators.max(100)]),
      'txtOrginationDate': new FormControl(this.model.OrginationDate),
      'txtMaturityDate': new FormControl(this.model.MaturityDate),
      'txtLender': new FormControl(this.model.Lender),
      'txtExpenses': new FormControl(this.model.Expenses),
      'txtExpenseReimbursement': new FormControl(this.model.ExpenseReimbursement),
      'txtTax': new FormControl(this.model.Tax),
      'txtTaxReimbursement': new FormControl(this.model.TaxReimbursement),
      'txtInsurance': new FormControl(this.model.Insurance),
      'txtInsuranceReimbursement': new FormControl(this.model.InsuranceReimbursement),
      'txtVideoUrl': new FormControl(this.model.VideoUrl, [
        vimeoUrlValidator(this.validationService)
      ]),

      /// portfolio end   //
    });

    if (this.isInEditMode) {

      this.loadPropertyDetails(this._propertyId);
      this.isInitialLoad = true;
    } else {
      this.isInitialLoad = true;
      const mapProp = {
        center: new google.maps.LatLng(40.7127753, -74.0059728),
        draggableCursor: 'auto',
        zoom: 5,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: true
      };
      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
      this.setCenter(40.7127753, -74.0059728, null);

      this.model.AutoCalcCapRate = false;
      this.model.AutoCalcPSF = true;
      this.loaderService.display(false);
      setTimeout(() => { this.isInitialLoad = false; }, 5000);
    }

    this.initAutocomplete();

    this.model.IsShowPrice = false;
  }

  get txtTenantTradeName() { return this.propForm.get('txtTenantTradeName'); }
  get txtTenantName() { return this.propForm.get('txtTenantName'); }
  get txtTenantNameFreeText() { return this.propForm.get('txtTenantNameFreeText'); }
  get txtGuarantorNameText() { return this.propForm.get('txtGuarantorNameText'); }
  get txtPropertSource() { return this.propForm.get('txtPropertSource'); }
  get txtNumberOfUnits() { return this.propForm.get('txtNumberOfUnits'); }
  get completer() { return this.propForm.get('completer'); }
  get rdFranchisee() { return this.propForm.get('rdFranchisee'); }
  get rdCoorporate() { return this.propForm.get('rdCoorporate'); }
  get radio1() { return this.propForm.get('radio1'); }
  get lstSandP() { return this.propForm.get('lstSandP'); }
  get lstMoodyRating() { return this.propForm.get('lstMoodyRating'); }
  get fitchRating() { return this.propForm.get('fitchRating'); }
  get txtGuarantor() { return this.propForm.get('txtGuarantor'); }
  get drpGuarantor() { return this.propForm.get('drpGuarantor'); }
  get txtAddress() { return this.propForm.get('txtAddress'); }
  get lstState() { return this.propForm.get('lstState'); }
  get lstCity() { return this.propForm.get('lstCity'); }
  get lstBrokerage() { return this.propForm.get('lstBrokerage'); }
  /*et lstBroker() { return this.propForm.get('lstBroker'); }*/
  get chkOfferMemoReqApproval() { return this.propForm.get('chkOfferMemoReqApproval'); }
  get chkDueDiligenceReqApproval() { return this.propForm.get('chkDueDiligenceReqApproval'); }
  get chkConfidentialityAgreement() { return this.propForm.get('chkConfidentialityAgreement'); }
  get chkDDConfidentialityAgreement() { return this.propForm.get('chkDDConfidentialityAgreement'); }

  get txtZip() { return this.propForm.get('txtZip'); }
  get lat() { return this.propForm.get('lat'); }
  get lon() { return this.propForm.get('lon'); }
  get txtYearBuilt() { return this.propForm.get('txtYearBuilt'); }
  get txtRenovated() { return this.propForm.get('txtRenovated'); }
  get lstPropertyType() { return this.propForm.get('lstPropertyType'); }
  get lstAssumable() { return this.propForm.get('lstAssumable'); }
  get lstAmortization() { return this.propForm.get('lstAmortization'); }
  get lstPrepay() { return this.propForm.get('lstPrepay'); }
  get lstSubcatgeories() { return this.propForm.get('lstSubcatgeories'); }
  get txtBuildingSF() { return this.propForm.get('txtBuildingSF'); }
  get txtland() { return this.propForm.get('txtland'); }
  get lstPropertyStatus() { return this.propForm.get('lstPropertyStatus'); }
  get txtNOI() { return this.propForm.get('txtNOI'); }
  get txtPSF() { return this.propForm.get('txtPSF'); }
  get txtCommencement() { return this.propForm.get('txtCommencement'); }
  get txtExpiration() { return this.propForm.get('txtExpiration'); }
  get txtOriginal() { return this.propForm.get('txtOriginal'); }
  get txtOriginalHdn() { return this.propForm.get('txtOriginalHdn'); }
  get txtEscalationPercentage() { return this.propForm.get('txtEscalationPercentage'); }
  get txtEscalationYrs() { return this.propForm.get('txtEscalationYrs'); }
  get txtOptionNumber() { return this.propForm.get('txtOptionNumber'); }
  get txtOptionLength() { return this.propForm.get('txtOptionLength'); }
  get chkNewTenantInfo() { return this.propForm.get('chkNewTenantInfo'); }
  get chkGurantorInfo() { return this.propForm.get('chkGurantorInfo'); }
  get lstLeaseStructure() { return this.propForm.get('lstLeaseStructure'); }
  get lstOwnershipType() { return this.propForm.get('lstOwnershipType'); }
  get txtAskingPrice() { return this.propForm.get('txtAskingPrice'); }
  get txtPricePSF() { return this.propForm.get('txtPricePSF'); }
  get txtCapRate() { return this.propForm.get('txtCapRate'); }
  get txtRemainingLeaseTerm() { return this.propForm.get('txtRemainingLeaseTerm'); }
  get txtOriginalLeaseTerm() { return this.propForm.get('txtOriginalLeaseTerm'); }
  get chkAutoCalcOriginalLeaseTerm() { return this.propForm.get('chkAutoCalcOriginalLeaseTerm'); }
  get chkAutoCalcCommencement() { return this.propForm.get('chkAutoCalcCommencement'); }
  get chkAutoCalcLeaseExpiration() { return this.propForm.get('chkAutoCalcLeaseExpiration'); }
  get chkAutoCalcRemainingLeaseTerm() { return this.propForm.get('chkAutoCalcRemainingLeaseTerm'); }
  get chkAutoCalcLeaseType() { return this.propForm.get('chkAutoCalcLeaseType'); }
  get chkAutoCalcRentalIncrease() { return this.propForm.get('chkAutoCalcRentalIncrease'); }
  get chkAutoCalcOptionNumber() { return this.propForm.get('chkAutoCalcOptionNumber'); }
  get chkAutoCalcOptionLength() { return this.propForm.get('chkAutoCalcOptionLength'); }
  get builtYear() { return this.model.YearBuilt; }
  get txtInsuranceReimbursement() { return this.propForm.get('txtInsuranceReimbursement'); }
  get txtInsurance() { return this.propForm.get('txtInsurance'); }
  get txtTaxReimbursement() { return this.propForm.get('txtTaxReimbursement'); }
  get txtTax() { return this.propForm.get('txtTax'); }
  get txtExpenseReimbursement() { return this.propForm.get('txtExpenseReimbursement'); }
  get txtExpenses() { return this.propForm.get('txtExpenses'); }
  get txtLender() { return this.propForm.get('txtLender'); }
  get txtMaturityDate() { return this.propForm.get('txtMaturityDate'); }
  get txtOrginationDate() { return this.propForm.get('txtOrginationDate'); }
  get txtInterestRate() { return this.propForm.get('txtInterestRate'); }
  get txtLoanAmount() { return this.propForm.get('txtLoanAmount'); }
  get txtAcquisitionCapRate() { return this.propForm.get('txtAcquisitionCapRate'); }
  get txtAcquisitionPrice() { return this.propForm.get('txtAcquisitionPrice'); }
  get txtVideoUrl() { return this.propForm.get('txtVideoUrl'); }

  resetContactModel() {

    this.randomID--;
    this.currentBrokerLicense = {
      UserId: 0,
      PropertyId: 0,
      PhoneNumber: null,
      Name: null,
      License: null,
      Id: this.randomID,
      BrokerRegionalLicenseId: 0,
      ContactType: null,
      ContactTypeId: 0,
      Email: null,
    };
  }
  resetSalesDetails() {
    this.currentSalesDetails = {
      Id: 0,
      PropertyId: 0,
      SaleDate: null,
      SalePrice: null,
      SaleCapRate: null,
      SalePSF: null,
      BrokerageId: null,
      AutoCalcCapRate: null,
      AutoCalcPSF: null,
      AutoPopulated: null,
      NOI: null,
      BuildingSize: null,
      DateOnMarket: null,
      YearOnMarket: null,
      MonthOnMarket: null,
      DayOnMarket: null,
      AskingPrice: null,
      AskingCapRate: null,
      DiscountToAsking: null,
      BuyerName: null,
      BuyerBrokerageName: null,
      BuyerBrokerName: null,
      SellerName: null,
      SellerBrokerageName: null,
      SellerBrokerName: null,
      RemainingTermYear: null,
      RemainingTermMonth: null,
      RemainingTermDay: null,
      Is1031ExchangeBuyer: false,
      SaleCharacteristicsId: null,
      AutoCalcDiscount: null,
      LTV: null,
      InterestRate: null,
      Amortization: null,
      Term: null,
      SalesNotes: null,
      GuarantorId: null,
      SPRatingId: null,
      MoodyRatingId: null,
      FitchRatingId: null,
      LeaseStructureId: null,
      RentEscalationPercentage: null,
      RentEscalationPeriod: null,
      OptionNumber: null,
      OptionLength: null,
      SalesNOI: null,
      BuyerBrokerageId: null
    };
  }

  bindBrokerage() {

    this.loggedUserDetails = this.authService.user;
    this.model.LoginUserId = this.loggedUserDetails.Id;

    this._userManagerService.getBrokerages(this.model.LoginUserId).subscribe(response => {
      this.brokerageList = response.map(o => { return { Id: o.Id, BrokerageName: o.BrokerageName }; });
    });
  }

  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  updateCapRate(text: string) {
    if (text == "AskingPrice") {
      this.updatePSF();
      this.reCalcRates(1, true);
    }
    if (this.model.AutoCalcCapRate) {
      this.model.CapRate = parseFloat(((this.model.NOI / this.model.Price) * 100).toFixed(2));
    }
    this.updateRentPSF();
  }

  updatePSF() {
    if (this.model.AutoCalcPSF) {
      this.model.PricePSF = this.model.BuildingSize > 0 ? parseFloat((this.model.Price / this.model.BuildingSize).toFixed(2)) : null;
    }
    if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Seller()) {
      this.updateRentPSF();
    }
  }

  updateRentPSF() {
    this.model.LeasePricePSF = this.model.BuildingSize > 0 && this.model.NOI != null && this.model.NOI != undefined ? parseFloat((this.model.NOI / this.model.BuildingSize).toFixed(2)) : null;
  }

  reCalcRates(typeId: number, isChecked) {
    if (isChecked) {
      switch (typeId) {
        case 1: //PFS
          this.model.PricePSF = this.model.BuildingSize > 0 ? parseFloat((this.model.Price / this.model.BuildingSize).toFixed(2)) : null;
          break;
        case 2: //CAP
          this.model.CapRate = parseFloat(((this.model.NOI / this.model.Price) * 100).toFixed(2));
          break;
      }
    }
  }

  bindCity() {
    // tslint:disable-next-line:no-debugger

    this._commonService.getCitiesList(this.model.StateId).subscribe(response => {
      this.citiesList = response.map(o => {
        return { Id: o.Id, Name: o.CityName };
      });
    });

    this.stateName = this.statesList.find(x => x.Id === this.model.StateId).Name;
    this.model.CityId = null;
  }

  validateDecimals() {
    this.model.CapRate = this.validationService.DecimalOnly(this.model.CapRate);
    this.model.BuildingSize = this.validationService.DecimalOnly(this.model.BuildingSize);
    this.model.Land = this.validationService.DecimalOnly(this.model.Land);
    this.model.RentEscalationPercentage = this.validationService.DecimalOnly(this.model.RentEscalationPercentage);
    this.model.PricePSF = this.validationService.DecimalOnly(this.model.PricePSF);
    this.model.LeasePricePSF = this.validationService.DecimalOnly(this.model.LeasePricePSF);
  }

  getContactTypeDisplayName(typeId: number) {
    switch (typeId) {
      case 551:
        return 'Primary';
      case 552:
        return 'Secondary';
      default:
        return 'Others';
    }
  }

  bindSubCategories(event = null) {
    if (this.model.PropertyTypeList != undefined && this.model.PropertyTypeList.length > 0) {
      this._commonService.getSubcategoryList(this.model.PropertyTypeList).subscribe(res => {
        this.subCategoriesList = res.map(o => {
          return { id: o["Id"], name: o["Name"] };
        });

        if (event != null) {
          this.changeCurrentSelection();
        }
      });
    }
    else {
      this.subCategoriesList = [];
      this.model.PropertyTypeSubcategoryList = [];
      this.cdRef.detectChanges();
    }
  }

  changeCurrentSelection() {
    let Subcategory: number[] = [];
    this.subCategoriesList.forEach(item => {
      if (this.model.PropertyTypeSubcategoryList.indexOf(item.id) > -1) {
        Subcategory.push(item.id);
      }
    });
    //var changeStatus = false;
    //Subcategory.forEach(item => {
    //    if (this.model.PropertyTypeSubcategoryList.indexOf(item) > -1) {
    //        changeStatus = true;
    //    }
    //});

    //if (changeStatus) {
    this.propForm.get("lstSubcatgeories").patchValue(Subcategory)
    //this.model.PropertyTypeSubcategoryList = [];
    //this.model.PropertyTypeSubcategoryList = Subcategory;
    //}
    this.cdRef.detectChanges();
  }

  getYearOfBuilt() {
    return this.model.YearBuilt;
  }

  //#region Events

  onFranchiseChange($event) {
    switch ($event) {
      case 'fr':
        this.isFranchise = this.model.IsFranchisee = true;
        this.isCorporate = false;
        // tslint:disable-next-line:no-debugger
        //

        this.propForm.get('txtNumberOfUnits').updateValueAndValidity();
        break;
      case 'cr':
        this.isFranchise = this.model.IsFranchisee = false;
        this.isCorporate = true;
        this.propForm.get('txtNumberOfUnits').updateValueAndValidity();
        break;
      default:
        this.isFranchise = this.model.IsFranchisee = true;
        this.isCorporate = false;
        break;
    }
  }

  onRatingOptionChange($event) {

    this.isSPR = $event === 'snr';
    this.isMoody = $event === 'moody';
    this.isFitch = $event === 'fitch';
  }

  onRemoveInvestmentHighlight(ih: PropertyHighlightsListOutputModel) {

    const i = this.model.InvestmentHighlights.findIndex(x => x.Id === ih.Id);

    this.model.InvestmentHighlights.splice(i, 1);

    this.propForm.get('txtIHTitle' + (ih.Id)).clearValidators();
    this.propForm.get('txtIHTitle' + (ih.Id)).updateValueAndValidity();

    this.propForm.get('txtIHDesc' + (ih.Id)).clearValidators();
    this.propForm.get('txtIHDesc' + (ih.Id)).updateValueAndValidity();
  }

  onTenantSelect(event) {
    if (event) {
      this.model.GuarantorId = null;
      this.model.TenantId = event.Id;
      this.model.TenantTradeName = event.TenantName != undefined ? event.TenantName : event.Name;
      this.bindGuarantor();
      this.bindPropertyTypeAndSubcategory();
      this.model.DisplayName = event.TenantName != undefined ? event.TenantName : event.Name;
      //this.resetRatingModels();
    }
    if (!event || (event.title != this.model.TenantTradeName && !event.Id)) {
      this.model.TenantId = 0;
      this.guarantorList = [];
      this.model.GuarantorId = null;
      this.resetRatingModels();
    }

  }
  //onChangeTenant() {
  //  this.model.TenantTradeName = this.model.TenantNameText;
  //  this.model.DisplayName = this.model.TenantNameText;
  //}
  bindPropertyTypeAndSubcategory() {
    this._commonService.GetTenantDetails(this.model.TenantId).subscribe(res => {
      this.model.PropertyTypeList = res["TypeId"];
      this.model.PropertyTypeSubcategoryList = res["SubcategoryId"];
    });
  }
  bindGuarantor() {
    if (this.model.TenantId && this.model.TenantId !== 0) {
      this.loaderService.display(true);
      this._commonService.GetGuarantorMappedToTenantList(this.model.TenantId).subscribe(res => {
        this.guarantorList = res.map(o => {
          return {
            Id: o.GuarantorId, Name: o.GuarantorName
          };
        });

        var Guarantor = res.find(x => x.Default)
        if (Guarantor && this.model.IsNewGuarantor != true && (this.model.GuarantorId == 0 || this.model.GuarantorId == null || this.model.GuarantorId == undefined)) {
          this.model.GuarantorId = Guarantor.GuarantorId;
          this.onGuarantorChanges();
        }

        this.loaderService.display(false);
      });
    }
  }

  onAddInvestmentHighlight() {

    let bigId = 0;
    this.model.InvestmentHighlights.forEach(ihx => {
      if (ihx.Id > bigId) {
        bigId = ihx.Id;
      }
    });

    const ih = {
      Title: null,
      Description: null,
      Id: bigId + 1 // Setting virtual id
    };

    this.model.InvestmentHighlights.push(ih);

    const lastIHTitleName = 'txtIHTitle' + (ih.Id);
    const lastIHDescName = 'txtIHDesc' + (ih.Id);
    this.propForm.addControl(lastIHTitleName, new FormControl(ih.Title, [Validators.required, spaceOnlyValidator]));
    this.propForm.addControl(lastIHDescName, new FormControl(ih.Description));
  }

  onNewFileUpload($event) {
    for (let index = 0; index < this.propDoc.nativeElement.files.length; index++) {
      const currentFile = this.propDoc.nativeElement.files[index];
      if (currentFile.type === 'application/pdf' || currentFile.type === 'image/x-dwg') {


        if (this.propertyDocuments.findIndex(x => x.Name === currentFile.name) > 0) {
          this._toastService.addToast({
            title: 'Duplicate File',
            msg: `The file '${currentFile.name}' already exists in the list`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'warning'
          });
          continue;
        }

        if (currentFile.name.length > 150) {
          this._toastService.addToast({
            title: 'Invalid File Name',
            msg: `The file name '${currentFile.name}' is too long`,
            timeout: 5000,
            theme: 'bootstrap',
            position: 'bottom-right',
            type: 'warning'
          });
          continue;
        }

        this.randomID--;

        const docx = {
          Category: null,
          Id: this.randomID,
          Name: currentFile.name,
          Url: null,
          FileContent: currentFile,
          CategoryId: null,
          IsNew: true,
          IsDefault: false
        };

        this.propertyDocuments.push(docx);

        const cmbName = 'cmbDocCat' + (docx.Id);
        this.propForm.addControl(cmbName, new FormControl(docx.CategoryId, Validators.required));
      } else {
        this._toastService.addToast({
          title: 'Error Extension',
          msg: `Please upload pdf/dwg files`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
      }
    }
    this.propDoc.nativeElement.value = '';
  }

  private CurrentFileSize(file: any) {
    var fileSizeinMB = file.size / (1024 * 1000);
    var size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place
    return size;
  }

  onRemoveLicence(index: number) {
    this.model.ContactOrBrokerInfo.splice(index, 1);
  }

  imageMaxSize: number = 10485760; // 10MB
  errorImages = [];
  onNewImageUpload($event) {
    this.errorImages = [];


    if (this.propImage.nativeElement.files.length > 5) {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Failed to upload. maximum 5 images at a time.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error'
      });
      return;
    }

    for (let index = 0; index < this.propImage.nativeElement.files.length; index++) {
      const reader = new FileReader();
      const currentFile = this.propImage.nativeElement.files[index];
      if (currentFile.type !== 'image/jpeg' && currentFile.type !== 'image/png') {
        this._toastService.addToast({
          title: 'Invalid File Format',
          msg: 'Kindly upload JPEG or PNG files',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
        continue;
      }

      if (currentFile.name.length > 150) {
        this._toastService.addToast({
          title: 'Invalid File Name',
          msg: `The file name '${currentFile.name}' is too long`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
        continue;
      }
      this.randomID--;
      if (currentFile.size > this.imageMaxSize) {
        this.errorImages.push(currentFile.name);
      }
      else {

        let img: any = {

          Name: currentFile.name,
          FileContent: currentFile,
          Url: '',
          IsDefault: (this.propertyImages.length == 0 && this.propertyImages.find(x => x.IsDefault == true) == null) ? true : false,
          Id: this.randomID,
          AlText: '',
          Caption: '',
          Description: '',
          DisplayOrder: 0

        };
        reader.onload = (e) => {
          img.Url = reader.result;

        };
        this.propertyImages.push(img);
        reader.readAsDataURL(currentFile);
        const displayOrder = 'txtDisplayOrder' + (img.Id);
        const alText = 'txtalText' + (img.Id);
        const caption = 'txtCaption' + (img.Id);
        const Description = 'txtLongDescription' + (img.Id);
        this.propForm.addControl(alText, new FormControl(img.AlText));
        this.propForm.addControl(caption, new FormControl(img.Caption));
        this.propForm.addControl(Description, new FormControl(img.Description));
        this.propForm.addControl(displayOrder, new FormControl(img.DisplayOrder));

      }
    }

    if (this.errorImages.length > 0) {
      let errorImageNames = '';
      this.errorImages.forEach(item => {
        errorImageNames += item + "<br>";
      });
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Failed to upload the following images. Image size too high. Try selecting images < 10MB. <br>' + errorImageNames,
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error'
      });
    }
    this.propImage.nativeElement.value = '';
  }

  onRemoveImage(id: number, index: number) {

    if (id > 0) {
      this.removedImageIds.push(id);
    }
    this._toastService.addToast({
      title: 'Success',
      msg: 'Image deleted successfully!',
      timeout: 5000,
      theme: 'bootstrap',
      position: 'bottom-right',
      type: 'success'
    });
    var val = this.propertyImages[index];
    this.propertyImages.splice(index, 1);

    if (val.IsDefault == true && this.propertyImages.length > 0) {

      this.setAsDefault(this.propertyImages[0].Id, 0);
    }

  }

  initAutocomplete() {
    this.autoComplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement,
      { types: ['geocode'], componentRestrictions: { country: "us" } });

    google.maps.event.addListener(this.autoComplete, 'place_changed', () => {
      const place = this.autoComplete.getPlace();
      this.fillInAddress(place);
    });
  }

  callZipChange($event) {
    this.ShowDuplicates = true;
    this.duplicatesFound = false;
    setTimeout(() => {
      this.onZipChange($event);
    }, 1000);
  }

  onZipChange($event) {
    if (this.citiesList != undefined && this.statesList != undefined) {
      const geocoder = new google.maps.Geocoder();
      let city = '';
      let state = '';
      if (this.model.CityId !== null) {
        const selectedCity = this.citiesList.filter(i => i.Id === this.model.CityId);
        city = selectedCity[0].Name;
        this.map.setZoom(15);
      }
      if (this.model.StateId !== null) {
        const selectedState = this.statesList.filter(i => i.Id === this.model.StateId);
        state = selectedState[0].Name;
      }
      const address = this.model.Address + ',' + city + ',' + state + this.model.Zip;
      var streetNumber = this.model.Address.replace(/(^\d+)(.+$)/i, '$1');
      const that = this;

      if (this.isPlacesApi) {
        const latitude = this.PlacesLat
        const longitude = this.PlacesLong;
        that.setCenter(latitude, longitude, null);
        this.isPlacesApi = false;
        this.onDuplicateChecking();
      }
      else {
        geocoder.geocode({ 'address': address }, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0].formatted_address.toLowerCase().includes(address.toLowerCase())) {
              const latitude = results[0].geometry.location.lat();
              const longitude = results[0].geometry.location.lng();
              that.setCenter(latitude, longitude, null);
            }
            else {
              var addressComponent = results[0].address_components;
              var components_by_type = {};
              for (var i = 0; i < addressComponent.length; i++) {
                var c = addressComponent[i];
                components_by_type[c.types[0]] = c;
              }

              if (components_by_type['administrative_area_level_1'].long_name == state &&
                components_by_type['locality'].long_name == city &&
                components_by_type['street_number'].long_name == streetNumber
                && components_by_type['postal_code'].long_name == that.model.Zip
              ) {
                const latitude = results[0].geometry.location.lat();
                const longitude = results[0].geometry.location.lng();
                that.setCenter(latitude, longitude, null);
              }
              else {
                that._toastService.addToast({
                  title: 'Attention Required!',
                  msg: 'Unable to find the address in Map. Please point the marker manually.',
                  timeout: 5000,
                  theme: 'bootstrap',
                  position: 'bottom-right',
                  type: 'warning'
                });
              }
            }
          } else {
            // Unable to find the address in Map. Please point the marker manually
            that._toastService.addToast({
              title: 'Attention Required!',
              msg: 'Unable to find the address in Map. Please point the marker manually.',
              timeout: 5000,
              theme: 'bootstrap',
              position: 'bottom-right',
              type: 'warning'
            });
          }

        });
        this.onDuplicateChecking();
      }
    }
  }
  checkLatLong() {
    const that = this;
    const geocoder = new google.maps.Geocoder();
    let city = '';
    let state = '';
    if (this.model.CityId !== null) {
      const selectedCity = this.citiesList.filter(i => i.Id === this.model.CityId);
      city = selectedCity[0].Name;
      this.map.setZoom(15);
    }
    if (this.model.StateId !== null) {
      const selectedState = this.statesList.filter(i => i.Id === this.model.StateId);
      state = selectedState[0].Name;
    }
    const address = this.model.Address;
    geocoder.geocode({ 'address': address }, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK) {
        const latitude = results[0].geometry.location.lat();
        const longitude = results[0].geometry.location.lng();
        that.setCenter(latitude, longitude, null);
        that.saveAPI();
      }
      else {
        that._toastService.addToast({
          title: 'Error',
          msg: 'Unable to find the address in Map. Please point the marker manually.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
        that.model.Zip = '';
        that.model.CityId = null;
        that.model.StateId = null;
      }
    });
    this.loaderService.display(false);
    window.scrollTo(0, 0);
  }

  onRemoveDocument(i: number) {
    const removed = this.propertyDocuments[i];
    this.removedDocIds.push(removed.Id);
    this.propForm.get('cmbDocCat' + (removed.Id)).clearValidators();
    this.propForm.get('cmbDocCat' + (removed.Id)).updateValueAndValidity();
    this.propertyDocuments.splice(i, 1);
    this._toastService.addToast({
      title: 'Success',
      msg: 'Document deleted!',
      timeout: 5000,
      theme: 'bootstrap',
      position: 'bottom-right',
      type: 'success'
    });

    //if (!removed.IsNew) {
    //    this._propertyManagementService.deleteDocument(removed.Id).subscribe(response => {
    //        if (response.toString() === 'true') {
    //            this._toastService.addToast({
    //                title: 'Success',
    //                msg: 'Document deleted!',
    //                timeout: 5000,
    //                theme: 'bootstrap',
    //                position: 'bottom-right',
    //                type: 'success'
    //            });

    //            this.propertyDocuments.splice(i, 1);
    //            this.propForm.get('cmbDocCat' + (removed.Id)).clearValidators();
    //            this.propForm.get('cmbDocCat' + (removed.Id)).updateValueAndValidity();
    //        } else {
    //            this._toastService.addToast({
    //                title: 'Error Occurred',
    //                msg: 'Image could not be deleted',
    //                timeout: 5000,
    //                theme: 'bootstrap',
    //                position: 'bottom-right',
    //                type: 'error'
    //            });
    //        }
    //    });
    //} else {
    //    this.propertyDocuments.splice(i, 1);
    //    this.propForm.get('cmbDocCat' + (removed.Id)).clearValidators();
    //    this.propForm.get('cmbDocCat' + (removed.Id)).updateValueAndValidity();
    //}
  }

  openModal(template: TemplateRef<any>, classes) {
    if (this.model.StateId || this.isPortfolio) {
      this.isBrokerFormEditMode = false;
      this.resetContactModel();
      this.modalRef = this.modalService.show(template, { class: classes });
    } else {
      this._toastService.addToast({
        title: 'State not Selected',
        msg: 'Select the state in the Location section',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });

      window.scrollTo({ behavior: 'smooth', left: 0, top: 300 });
    }
  }

  openModalForEdit(template: TemplateRef<any>, classes, brokerIndex: number) {
    if (this.model.StateId || this.isPortfolio) {
      this.isBrokerFormEditMode = true;
      this.currentBrokerLicense = Object.assign({}, this.model.ContactOrBrokerInfo[brokerIndex]);
      this.modalRef = this.modalService.show(template, { class: classes });
    } else {
      this._toastService.addToast({
        title: 'State not Selected',
        msg: 'Select the state in the Location section',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });

      window.scrollTo({ behavior: 'smooth', left: 0, top: 300 });
    }
  }


  closeModal(event) {
    this.brokerslist.push(event);
    this.modalRef.hide();
    this.isBrokerFormEditMode = false;
  }

  onAddBrokerLicence(brokerLicense: SavePropertyBrokerInputModel) {


    if (brokerLicense.ContactTypeId == 551) {
      var duplicatePrimary = this.model.ContactOrBrokerInfo.find(x => x.ContactTypeId == 551 && x.Id != brokerLicense.Id);
      if (duplicatePrimary != undefined) {
        this._toastService.addToast({
          title: 'Duplicate Primary Contact',
          msg: 'Primary contact already exists for this property',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
        return;
      }
    }
    var findBroker = this.model.ContactOrBrokerInfo.find(x => x.UserId === brokerLicense.UserId);
    if (findBroker != undefined && brokerLicense.Id != findBroker.Id) {
      this._toastService.addToast({
        title: 'Duplicate Contact',
        msg: 'The selected broker already exists in the property contact list',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });

      return;
    }

    if (this.isBrokerFormEditMode) {
      let updateBroker = this.model.ContactOrBrokerInfo.find(x => x.Id === brokerLicense.Id);
      updateBroker.UserId = brokerLicense.UserId;
      updateBroker.BrokerRegionalLicenseId = brokerLicense.BrokerRegionalLicenseId;
      updateBroker.License = brokerLicense.License;
      updateBroker.ContactTypeId = brokerLicense.ContactTypeId,
        updateBroker.ContactType = brokerLicense.ContactType,
        updateBroker.Email = brokerLicense.Email,
        updateBroker.Id = brokerLicense.Id,
        updateBroker.Name = brokerLicense.Name,
        updateBroker.PhoneNumber = brokerLicense.PhoneNumber,
        updateBroker.PropertyId = brokerLicense.PropertyId
    } else {
      this.model.ContactOrBrokerInfo.push({
        BrokerRegionalLicenseId: brokerLicense.BrokerRegionalLicenseId,
        ContactTypeId: brokerLicense.ContactTypeId,
        ContactType: brokerLicense.ContactType,
        Email: brokerLicense.Email,
        Id: brokerLicense.Id,
        License: brokerLicense.License,
        Name: brokerLicense.Name,
        PhoneNumber: brokerLicense.PhoneNumber,
        UserId: brokerLicense.UserId,
        PropertyId: brokerLicense.PropertyId
      });
    }
    this.modalRef.hide();
  }

  onLeaseDatesChange($event) {
    if (this.isPropertyForSale) {
      //const d1 = moment(this.model.LeaseExpiration);
      //const d2 = moment(this.model.LeaseCommencementDate);
      //this.model.OriginalLeaseTerm = d1.diff(d2, 'years', false);
      this.txtRenovated.updateValueAndValidity();
    }
    else {
      this.model.OriginalLeaseTerm = null;
    }
  }
  confirmPropertyForSelection() {
    this.isPropertyForSale = this.model.PropertyForId === 601;


    // Dynamically add/removing validators for the unwanted controls

    if (this.isPropertyForSale) {
      this.txtNumberOfUnits.setValidators([Validators.min(1)]);
    } else {
      this.txtNumberOfUnits.clearValidators();
    }

    this.txtNumberOfUnits.updateValueAndValidity();



    //if (this.isPropertyForSale) {
    //    this.txtYearBuilt.setValidators([Validators.required,
    //    Validators.max(this.today.getFullYear()),
    //        Validators.min(1920)]);
    //} else {
    //    this.txtYearBuilt.clearValidators();
    //}
    //this.txtYearBuilt.updateValueAndValidity();

    if (this.isPropertyForSale) {
      //this.txtRenovated.setValidators([Validators.required,
      this.txtRenovated.setValidators([
        Validators.max(this.today.getFullYear()),
        minValidator(() => this.builtYear)]);
    } else {
      this.txtRenovated.clearValidators();
    }


    this.txtRenovated.updateValueAndValidity();

    if (this.isPropertyForSale) {
      this.txtPSF.setValidators([Validators.required,
      Validators.min(0)]);
    } else {
      this.txtPSF.clearValidators();
    }

    this.txtPSF.updateValueAndValidity();
  }
  onPropertyForChanged(event) {

    if (this.model.PropertyForId === 601) {
      this.propertyFor = "B+E Listing";
    }
    else {
      this.propertyFor = "1031 Trade";
    }
    if (event !== null) {
      this.modalRefPropertyForSelection = this.modalService.show(this.propertyForSelection, { class: 'deletemodal' });
    }
    this.confirmPropertyForSelection();
  }

  //#endregion
  //#endregion

  saveMethod(template: TemplateRef<any>) {
    //this.loaderService.display(false);

    this.loaderService.display(true);
    if (this.modalRefPropertyForConfirmation !== undefined) {
      this.modalRefPropertyForConfirmation.hide();
    }
    if (this.model.IsSourceChanged === 1) {
      this.loaderService.display(false);
      this.modalRef = this.modalService.show(template, { class: 'deletemodal' });
    }
    else {
      this.callSaveApiMethod(false);
    }

  }
  RemoveConfirm() {
    this.modalRefPropertyForConfirmation.hide()
  }
  adminSaveOnlyClick = false;
  saveChanges(template?: TemplateRef<any>, type?: number) {
    this.model.SaveAsDraft = false;
    this.model.IsPortfolio = this.isPortfolio;
    this.model.TenantName = this.model.TenantNameText != null ? this.model.TenantNameText : this.model.TenantName;
    this.model.UserGuid = this.UserGuid;
    if (this.model.PropertyStatusId == 6906) {
      this.model.IsSaveOnly = true;
      this.adminSaveOnlyClick = true;
      this.model.SaveAsDraft = true;
      this.model.DataEntryPropertyStatusId = this.propertyStatus.Draft;
      this.addOrRemoveValidateion(true);
    }
    else {
      if (type == 3) {
        if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
          this.model.IsSaveOnly = false;
          this.adminSaveOnlyClick = false;
          this.model.DataEntryPropertyStatusId = this.model.DataEntryPropertyStatusId == this.propertyStatus.Draft ? this.propertyStatus.PendingApproval : this.model.DataEntryPropertyStatusId;
          this.addOrRemoveValidateion(true);
        }
        else {
          this.model.IsSaveOnly = false;
          this.adminSaveOnlyClick = false;
          this.model.DataEntryPropertyStatusId = this.model.DataEntryPropertyStatusId == this.propertyStatus.Draft ? this.propertyStatus.PendingApproval : this.model.DataEntryPropertyStatusId;
          this.addOrRemoveValidateion(true);
        }
      }
      else {
        this.model.IsSaveOnly = true;
        this.adminSaveOnlyClick = true;
        this.model.DataEntryPropertyStatusId = this.model.DataEntryPropertyStatusId == this.propertyStatus.Draft ? this.propertyStatus.PendingApproval : this.model.DataEntryPropertyStatusId;
        this.addOrRemoveValidateion(true);
      }
    }

    if (this.model.LeaseCommencementDate != null && this.model.LeaseExpiration != null && !this.isPortfolio) {
      const cDate = new Date(this.model.LeaseCommencementDate);
      const isYes = cDate > (this.model.LeaseExpiration as Date);
      if (isYes) {
        this._toastService.addToast({
          title: 'Unable to save changes',
          msg: 'Lease expiration date should be after the commencement date.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
        return;
      }
    }
    this.isSubmitted = true;
    this.loaderService.display(true);
    this.validateDecimals();

    if (!this.propForm.invalid) {
      if (((this.model.TenantId == 0 || this.model.TenantId == null) && (this.model.TenantNameText == null || this.model.TenantNameText == '')) && type != 1 && !this.isPortfolio) { // If no tenant is selected from the auto complete list
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'Please select a tenant from the list / Enter a tenant name',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error'
        });
        this.loaderService.display(false);
        $('html,body').animate({ scrollTop: 0 }, 500);
        return;
      }

      if (this.model.LeaseCommencementDate != null) {
        this.model.LeaseCommencementDate = this.utcify(this.model.LeaseCommencementDate);
      }
      this.model.LeaseExpiration = this.utcify(this.model.LeaseExpiration);

      if (this.model.PropertyRentTerm != undefined && this.model.PropertyRentTerm.length > 0) {
        for (let i = 0; i < this.model.PropertyRentTerm.length; i++) {
          this.model.PropertyRentTerm[i].LeaseStartDate = this.validationService.utcify(this.model.PropertyRentTerm[i].LeaseStartDate);
          this.model.PropertyRentTerm[i].LeaseEndDate = this.validationService.utcify(this.model.PropertyRentTerm[i].LeaseEndDate);
        }
      }

      if (this.model.PropertySalesInputModel != null && this.model.PropertySalesInputModel != undefined && this.model.PropertySalesInputModel.length > 0) {
        for (let i = 0; i < this.model.PropertySalesInputModel.length; i++) {
          this.model.PropertySalesInputModel[i].SaleDate = this.validationService.utcify(new Date(this.model.PropertySalesInputModel[i].SaleDate));
          this.model.PropertySalesInputModel[i].DateOnMarket = this.validationService.utcify(new Date(this.model.PropertySalesInputModel[i].DateOnMarket));
          if (this.model.PropertySalesInputModel[i].SaleHistoryRentTerm) {
            this.model.PropertySalesInputModel[i].SaleHistoryRentTerm.forEach(item => {
              item.LeaseStartDate = this.validationService.utcify(item.LeaseStartDate);
              item.LeaseEndDate = this.validationService.utcify(item.LeaseEndDate);
            })
          }
        }
      }

      if (this.model.PropertyLeasingHistoryInputModel != null && this.model.PropertyLeasingHistoryInputModel != undefined && this.model.PropertyLeasingHistoryInputModel.length > 0) {
        for (let i = 0; i < this.model.PropertyLeasingHistoryInputModel.length; i++) {
          this.model.PropertyLeasingHistoryInputModel[i].Date = this.validationService.utcify(new Date(this.model.PropertyLeasingHistoryInputModel[i].Date));
          this.model.PropertyLeasingHistoryInputModel[i].LeaseCommencementDate = this.validationService.utcify(new Date(this.model.PropertyLeasingHistoryInputModel[i].LeaseCommencementDate));
          this.model.PropertyLeasingHistoryInputModel[i].LeaseExpireDate = this.validationService.utcify(new Date(this.model.PropertyLeasingHistoryInputModel[i].LeaseExpireDate));
          this.model.PropertyLeasingHistoryInputModel[i].LeaseStartDate = this.validationService.utcify(new Date(this.model.PropertyLeasingHistoryInputModel[i].LeaseStartDate));
        }
      }


      if (!this.model.Guarantor) { this.model.Guarantor = 'Corporate'; }

      this.model.OriginalLeaseTerm = null;
      this.loaderService.display(false);

      if (this.model.OfferMemoReqApproval == null) {
        this.model.OfferMemoReqApproval = false;
      }
      if (this.model.DueDiligenceReqApproval == null) {
        this.model.DueDiligenceReqApproval = false;
      }
      if (this.model.ConfidentialityAgreement == null) {
        this.model.ConfidentialityAgreement = false;
      }
      if (this.model.DDConfidentialityAgreement == null) {
        this.model.DDConfidentialityAgreement = false;
      }

      // if page is in edit mode and no tenant change has perfomed then no need to check duplicate
      if (this.isInEditMode) {
        this.saveMethodAfterDuplicateCheck(template);
      }
      else {
        // check for dupplicate property

        let input = {
          PropertyId: this.model.Id,
          Address: this.model.Address,
          StateId: this.model.StateId,
          CityId: this.model.CityId,
          Zip: this.model.Zip,
        }
        this.saveMethodAfterDuplicateCheck(template);
        //this._propertyManagementService.GetDuplicatePropertyList(input).subscribe(response => {
        //  if (response.length > 0) {
        //    this.modalRefDuplicates = this.modalService.show(this.DuplicateTemplate, { class: 'deletemodal' });
        //  }
        //  else {
        //    this.saveMethodAfterDuplicateCheck(template);
        //  }
        //});

      }
    }
    else {
      this.propForm.updateValueAndValidity();
      this._toastService.addToast({
        title: 'Unable to save changes',
        msg: 'Some fields still have invalid data or some mandatory fields are missing.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
      this.loaderService.display(false);
    }
  }

  saveMethodAfterDuplicateCheck(template: any) {

    if (this.modalRefDuplicates) {
      this.modalRefDuplicates.hide();
    }
    if (this.model.LiveListingId || this.adminSaveOnlyClick) {
      this.saveMethod(template);
    }
    else {
      let tennat = this.model.TenantName;
      this.modalRefPropertyForConfirmation = this.modalService.show(this.propertyForConfirmation, { class: 'deletemodal' });
    }
  }

  item: any;
  labelForAddOrEdit = "";
  openModalBroker(template: TemplateRef<any>, classes: any, data: any) {
    if (this.model.BrokerageId > 0) {
      this.brokerageBrokerInputModel.BrokerName = "";
      this.brokerageBrokerInputModel.LastName = "";
      this.brokerageBrokerInputModel.Email = "";
      this.brokerageBrokerInputModel.Phone = "";
      this.brokerageBrokerInputModel.Title = "";
      this.brokerageBrokerInputModel.AdditionalPhone = "";
      this.brokerageBrokerInputModel.ExtensionNumber = "";
      this.labelForAddOrEdit = "Add Broker";
      this.brokerageBrokerInputModel.BrokerageId = this.model.BrokerageId;
      this.modalRef = this.modalService.show(template, { class: classes });
    }
    else {
      this._toastService.addToast({
        title: 'Unable to select brokers',
        msg: 'Please select a brokerage to select a broker',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
  }

  selectedBrokers = [];
  brokerageId = 0;
  openModalBrokerage(template: TemplateRef<any>, classes) {
    if (this.model.BrokerageId <= 0) {
      this._toastService.addToast({
        title: 'Unable to select brokers',
        msg: 'Please select a brokerage to select an external broker',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'warning'
      });
    }
    else {
      this.selectedBrokers = [];
      this.brokerslist.forEach(item => {
        this.selectedBrokers.push(item.Id);
      });

      this.brokerageId = this.model.BrokerageId;
      this.brokerageName = this.brokerageList.filter(i => i.Id == this.brokerageId)[0].BrokerageName;
      this.modalRef = this.modalService.show(template, { class: classes });
    }

  }
  brokerslist = [];
  brokerageName = null;
  SaveBrokers(Id: number, index: number) {
    if (Id != null) {
      this._brokerageManagerService.getBrokerDetails(Id).subscribe(response => {
        if (response != null) {
          //this.brokerageBrokersList(response.map(o => { return { Id: o.Id, BrokerName: o.BrokerName, Email: o.Email, Phone: o.Phone }; }));
          this.users.splice(index, 1);
          this.brokerslist.push(response);

        }
      });
    }
  }
  onRemoveBrokers(index: number) {
    this.brokerslist.splice(index, 1);
    this.model.BrokerList = this.brokerslist;
  }
  callSaveApiMethod(IsUpdate) {

    this.loaderService.display(true);
    if (IsUpdate) {
      this.model.IsMarked = true;
    }
    else {
      this.model.IsMarked = false;
    }

    if (this.model.IsSourceChanged) {
      this.modalRef.hide();
    }

    if (!this.isInEditMode) {
      if (this.authService.DataEntryStaff()) {
        this.model.DataEntryPropertyStatusId = 357;

      }
    }

    this.model.BrokersId = [];
    this.brokerslist.forEach(x => {
      this.model.BrokersId.push(x.Id);
    })

    if (this.model.Address == null || this.model.Address == "") {
      this.model.Latitude = 0;
      this.model.Longitude = 0;
    }

    if (this.model.Latitude == 40.7127753 && this.model.Longitude == -74.0059728 && !this.isPortfolio) {
      this.checkLatLong();
    }
    else {
      this.saveAPI();
    }
  }

  saveAPI() {
    this.loaderService.display(true);
    this._propertyManagementService.SavePortfolioProperty(this.model).subscribe(response => {

      this.loaderService.display(true);
      if (!response.Success) {
        this._toastService.addToast({
          title: 'Error', msg:
            response.ReturnMsg, timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
        this.loaderService.display(false);
        window.scrollTo(0, 0);
        return;
      }

      const fileUploadStatuses = this.uploadPropertyFiles(response.Id);
      if (this.uploadedFiles.length > 0) {

        fileUploadStatuses.forEach(status => {

          status.subscribe(
            data => {

              const uploadedItem = this.uploadedFiles.find(item => item.id === data[0].RandomId);
              if (uploadedItem !== undefined && uploadedItem.type === 'Images') {
                const defaultImage = this.propertyImages.find(item => item.IsDefault === true
                  && item.Id === data[0].RandomId);
                if (defaultImage !== undefined) {
                  defaultImage.Id = data[0].UploadedFileId;
                }
              }
              if (uploadedItem !== undefined && uploadedItem.type === 'Documents') {
                const prDoc = this.propertyDocuments.find(item => item.Id === data[0].RandomId);
                if (prDoc !== undefined) {
                  prDoc.Id = data[0].UploadedFileId;
                }
              }

              if (this.uploadedFiles.length === this.fileUploadCount + 1) {
                if (this.isInEditMode) {
                  const defaultImg = this.propertyImages.find(item => item.IsDefault === true);
                  if (defaultImg !== undefined) {
                    this._propertyManagementService.setDefaultImage(defaultImg.Id).subscribe((x: {}[]) => { });
                  }
                  else {
                    this._propertyManagementService.setDefaultImage(data[0].UploadedFileId).subscribe(x => { });
                  }
                }
                if (this.propertyImages.length > 0) {
                  this.propertyImages.forEach(img => {
                    this.imageDetailList.push({
                      Id: img.Id,
                      AlText: img.AlText,
                      Caption: img.Caption,
                      Description: img.Description,
                      DisplayOrder: img.DisplayOrder
                    });
                  });
                  this._propertyManagementService.saveImageDetail(this.imageDetailList).subscribe(x => { });
                }
                if (this.propertyDocuments.length > 0) {
                  this.propertyDocuments.forEach(doc => {
                    this.documentCategoryList.push({
                      Id: doc.Id,
                      CategoryId: doc.CategoryId
                    });
                  });
                  this._propertyManagementService.saveDocumentCategory(this.documentCategoryList).subscribe(x => { });
                }
                this.model.Id = response.Id;
                this.model.IsDataEntryProperty = true;

                let message = '';
                if (this.propertyDocuments != null && this.propertyDocuments.length > 0) {
                  let newdata = this.propertyDocuments.filter(c => c.FileContent != null);
                  if (newdata != null && newdata.length > 0) {
                    message = " File uploads are in progress, please don't reload or close the website until complete.";
                  }
                }
                this._toastService.addToast({
                  title: 'Success', msg:
                    (this.isPortfolio ? 'Portfolio' : 'Property') + ' information saved Successfully <br/>', timeout:
                    5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
                });

                if (message != '') {
                  this._toastService.addToastWithoutClear({ title: '', msg: message, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'info' });
                }

                if (this.removedDocIds != null && this.removedDocIds.length > 0) {
                  this._propertyManagementService.deleteMultipleDocument(this.removedDocIds, this.loggedUserDetails.Id).subscribe(res => {
                    this.removedDocIds = [];
                    this.loadViewdeProperty(response.Guid);
                  });
                }
                else {
                  this.loadViewdeProperty(response.Guid);
                }
                if (this.removedImageIds != null && this.removedImageIds.length > 0) {
                  this._propertyManagementService.deleteMultipleImage(this.removedImageIds, this.loggedUserDetails.Id).subscribe(res => {
                    this.removedImageIds = [];
                    this.loadViewdeProperty(response.Guid);
                    this._propertyManagementService.savePropertyDocAndImages(this.model).subscribe(x => { });
                  });
                }
                else {
                  setTimeout(() => { this._propertyManagementService.savePropertyDocAndImages(this.model).subscribe(x => { }); }, 3000);
                  this.loadViewdeProperty(response.Guid);
                }

              }
              else {
                this.fileUploadCount++;
              }
            },
            err => console.log(err)
          );
        });
      }
      else {
        if (this.isInEditMode) {
          const defaultImg = this.propertyImages.find(item => item.IsDefault === true);
          if (defaultImg !== undefined) {
            this._propertyManagementService.setDefaultImage(defaultImg.Id).subscribe(x => { });
          }
        }
        if (this.propertyImages.length > 0) {
          this.propertyImages.forEach(img => {
            this.imageDetailList.push({
              Id: img.Id,
              AlText: img.AlText,
              Caption: img.Caption,
              Description: img.Description,
              DisplayOrder: img.DisplayOrder
            });
          });
          this._propertyManagementService.saveImageDetail(this.imageDetailList).subscribe(x => { });
        }
        if (this.propertyDocuments.length > 0) {
          this.propertyDocuments.forEach(doc => {
            this.documentCategoryList.push({
              Id: doc.Id,
              CategoryId: doc.CategoryId
            });
          });
          this._propertyManagementService.saveDocumentCategory(this.documentCategoryList).subscribe(x => { });
        }
        this.model.Id = response.Id;
        this.model.IsDataEntryProperty = true;

        let message = '';
        if (this.propertyDocuments != null && this.propertyDocuments.length > 0) {
          let newdata = this.propertyDocuments.filter(c => c.FileContent != null);
          if (newdata != null && newdata.length > 0) {
            message = " File uploads are in progress, please don't reload or close the website until complete.";
          }
        }
        if (this.removedDocIds != null && this.removedDocIds.length > 0) {
          this._propertyManagementService.deleteMultipleDocument(this.removedDocIds, this.loggedUserDetails.Id).subscribe(res => {
            this.removedDocIds = [];
            this.loadViewdeProperty(response.Guid);
          });
        }
        else {
          this.loadViewdeProperty(response.Guid);
        }
        if (this.removedImageIds != null && this.removedImageIds.length > 0) {

          this._propertyManagementService.deleteMultipleImage(this.removedImageIds, this.loggedUserDetails.Id).subscribe(res => {
            this.removedImageIds = [];
            this.loadViewdeProperty(response.Guid);
            this._propertyManagementService.savePropertyDocAndImages(this.model).subscribe(x => { });
          });
        }
        else {
          setTimeout(() => { this._propertyManagementService.savePropertyDocAndImages(this.model).subscribe(x => { }); }, 3000);
          this.loadViewdeProperty(response.Guid);
        }

      }

      this._toastService.addToast({
        title: 'Success', msg:
          (this.isPortfolio ? 'Portfolio' : 'Property') + ' information saved Successfully ', timeout:
          5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
      });
      this.loaderService.display(false);
      this.onBreadCrumbClick();
    });

  }

  private currentIndex: number;
  uploadPropertyFiles(propertyId: number): Observable<any>[] {
    // tslint:disable-next-line:no-debugger
    this.currentIndex = 0;
    this.propertyImages.forEach(image => {
      this.currentIndex = this.currentIndex + 1;
      if (image.FileContent === null) {
        return;
      }

      this.uploadedFiles.push({
        id: image.Id,
        objectId: propertyId,
        type: 'Images',
        documentName: image.Name,
        fileCategoryId: 252, // Building images
        objectTypeId: 305,
        FileContent: image.FileContent,
        isDefault: image.IsDefault,
        AlText: image.AlText,
        Caption: image.Caption,
        Description: image.Description,
        DisplayOrder: this.currentIndex,

      });
    });

    this.propertyDocuments.forEach(doc => {
      if (doc.FileContent === null) {
        return;
      }
      let url = '/property-detail/' + this.model.Guid + '?iscreated=1&UserGuid=' + this.UserGuid
      this.uploadedPropertyDocuments.push({
        id: doc.Id,
        objectId: propertyId,
        type: 'Documents',
        documentName: doc.Name,
        fileCategoryId: doc.CategoryId,
        objectTypeId: 305,
        FileContent: doc.FileContent,
        isDefault: false,
        sourceUrl: url,
        ImageGuid: this.newGuid(),
      });
    });
    if (this.uploadedPropertyDocuments != null && this.uploadedPropertyDocuments.length > 0) {
      this.imageupload();
    }
    const fileUploadResponses: Observable<any>[] = [];
    this.uploadedFiles.forEach(file => {
      const status = this._fileUploadService.uploadFile(file);
      fileUploadResponses.push(status);
    });

    return fileUploadResponses;
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  imageupload() {
    this._auth0.ImageUPload(this.uploadedPropertyDocuments);
    this.uploadedPropertyDocuments = [];
  }
  private datetify(date: any): Date {
    if (date) {
      return new Date(date);
    } else {
      return new Date();
    }
  }

  private utcify(date: Date): Date {
    if (date) {
      return new Date(date.toUTCString());
    } else {
      return new Date();
    }
  }
  onBrokerageChange() {
    this.brokerslist = [];
    this._toastService.addToast({
      title: 'Success',
      msg: 'Brokerage details updated',
      timeout: 5000,
      theme: 'bootstrap',
      position: 'bottom-right',
      type: 'success'
    });
  }

  loadPropertyDetails(id: string) {
    this.loaderService.display(true);

    this._propertyManagementService.getDataEntryPropertyDetails(id).subscribe(x => {
      if (this.isPortfolio) {
        this.model.AutoCalcPrice = x.AutoCalcPrice == null ? true : x.AutoCalcPrice;
      }
      this.model.PropertyStatusId = x.PropertyStatusId;
      this.model.Address = x.Address;
      this.model.TenantNameText = x.TenantNameText;
      this.model.GuarantorName = x.GuarantorName;
      this.model.Address = x.Address;
      this.model.BuildingSize = x.BuildingSize;
      this.model.CapRate = x.CapRate;
      this.model.BrokerageId = x.BrokerageId == 0 ? null : x.BrokerageId;
      this.model.BrokersId = x.BrokersId;
      this.brokerslist = x.BrokerList;
      this.model.DateOnMarket = x.DateOnMarket ? this.validationService.convertUTCDateToLocalDate(x.DateOnMarket) : null;
      this.model.Description = x.Description;
      this.model.PropertySource = x.PropertySource;
      this.model.FitchRatingId = x.FitchRatingId;
      this.model.Guarantor = x.Guarantor;
      this.model.Guid = x.Guid;
      this.model.Id = x.Id;
      this.model.IsFeatured = x.IsFeatured;
      this.model.IsFranchisee = x.IsFranchisee;
      this.model.IsShowPrice = x.IsShowPrice;
      this.model.Land = x.Land;
      this.model.Latitude = x.Latitude;
      this.model.LeaseCommencementDate = x.LeaseCommencementDate ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : null;
      this.model.LeaseExpiration = this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration);
      this.model.LeasePricePSF = x.LeasePricePSF;
      this.model.LeaseStructureId = x.LeaseStructureId;
      this.model.Longitude = x.Longitude;
      this.model.MoodyRatingId = x.MoodyRatingId;
      this.model.NOI = x.NOI;
      this.model.NoOfUnits = x.NoOfUnits;
      this.model.OptionLength = x.OptionLength;
      this.model.OptionNumber = x.OptionNumber;
      this.model.OriginalLeaseTerm = x.OriginalLeaseTerm;
      this.model.OwnershipTypeId = x.OwnershipTypeId;
      this.model.Price = x.Price;
      this.model.PricePSF = x.PricePSF;
      this.model.PropertyForId = x.PropertyForId;
      this.model.DataEntryPropertyStatusId = x.DataEntryPropertyStatusId;
      this.dataEntryPropertyStatusId = x.DataEntryPropertyStatusId;
      this.isPropertyForSale = false;
      this.onPropertyForChanged(null);
      this.model.Notes = x.Notes;
      this.model.PropertyTypeId = x.PropertyTypeId;
      this.model.PropertyTypeList = x.PropertyTypeList;
      this.bindSubCategories();
      this.model.SubCategoryId = x.SubCategoryId;
      this.model.PropertyTypeSubcategoryList = x.PropertyTypeSubcategoryList;
      this.model.Unpriced = x.Unpriced;
      this.model.ConfidentialLocation = x.ConfidentialLocation;
      this.model.UnpricedText = x.Unpriced ? 'Unpriced' : '';
      this.model.CapRateText = x.Unpriced ? 'Unpriced' : '';
      this.model.IsNewTenant = this.model.TenantId == null && this.model.TenantNameText != null ? true : false;
      this.model.IsNewGuarantor = this.model.GuarantorId == null && this.model.GuarantorName != null ? true : false;
      this.model.Renovated = x.Renovated;
      this.model.RentEscalationPercentage = x.RentEscalationPercentage;
      this.model.RentEscalationPeriod = x.RentEscalationPeriod;
      this.model.SPRatingId = x.SPRatingId;
      this.model.MetaTags = x.MetaTags;
      this.model.StateId = x.StateId;
      this.model.AcquisitionCapRate = x.AcquisitionCapRate;
      this.model.AcquisitionPrice = x.AcquisitionPrice;
      this.model.Amortization = x.Amortization;
      this.model.Assumable = x.Assumable;
      this.model.ExpenseReimbursement = x.ExpenseReimbursement;
      this.model.Expenses = x.Expenses;
      this.model.Insurance = x.Insurance;
      this.model.InsuranceReimbursement = x.InsuranceReimbursement;
      this.model.InterestRate = x.InterestRate;
      this.model.OrginationDate = x.OrginationDate ? this.validationService.convertUTCDateToLocalDate(x.OrginationDate) : null;
      this.model.MaturityDate = x.MaturityDate ? this.validationService.convertUTCDateToLocalDate(x.MaturityDate) : null;
      this.model.Tax = x.Tax;
      this.model.TaxReimbursement = x.TaxReimbursement;
      this.model.Lender = x.Lender;
      this.model.LoanAmount = x.LoanAmount;
      this.model.PrePay = x.PrePay;
      this.model.AutoCalcCapRate = x.AutoCalcCapRate;
      if (x.StateId != null) {
        this.bindCity();
      }

      this.model.CityId = x.CityId;
      if (x.IsFranchisee) {
        $('input:radio[id=Franchisee]').prop('checked', true);
      }
      else {
        $('input:radio[id=Corporate]').prop('checked', true);
      }
      this.model.TenantId = x.TenantId;
      this.model.TenantName = x.TenantName;
      this.model.TenantTradeName = x.TenantTradeName;
      this.model.VideoUrl = x.VideoUrl;
      this.model.YearBuilt = x.YearBuilt;
      this.model.Zip = x.Zip;

      this.model.DueDiligenceReqApproval = x.DueDiligenceReqApproval;
      this.model.OfferMemoReqApproval = x.OfferMemoReqApproval;
      this.model.ConfidentialityAgreement = x.ConfidentialityAgreement;
      this.model.DDConfidentialityAgreement = x.DDConfidentialityAgreement;


      this.model.IsComp = x.IsComp;
      this.model.IsArchive = x.IsArchive;
      this.model.IsSourceChanged = x.IsSourceChanged;
      this.model.AutoCalcCapRate = this.model.Id == 0 ? true : x.AutoCalcCapRate;
      this.model.AutoCalcPSF = this.model.Id == 0 ? true : x.AutoCalcPSF;
      this.model.IsRentTermAutoCalc = this.model.Id == 0 || x.IsRentTermAutoCalc == null ? true : x.IsRentTermAutoCalc;
      this.retnTermAutoCalcValue = this.model.Id == 0 || x.IsRentTermAutoCalc == null ? true : x.IsRentTermAutoCalc;
      this.model.PropertyRentTerm = x.PropertyRentTerm;
      this._sharedService.setPropertyRentTermValue(x.PropertyRentTerm);
      this.IsRentTableVisible = true;
      this.model.IsShowRentSchedule = x.IsShowRentSchedule;
      this.isCorporate = !(this.isFranchise = this.model.IsFranchisee);
      this.model.LiveListingId = x.LiveListingId;
      this.model.GuarantorId = x.GuarantorId;
      if (!this.model.IsPortfolio) {
        this.bindGuarantor();
      }
      if (this.authService.Principal() || this.authService.Principal1031() || this.authService.Seller()) {
        this.disablePropertyStatus = true;
      }
      else {
        if (this.model.PropertyStatusId == 6906) {
          this.disablePropertyStatus = true;
        }
        else {
          this.disablePropertyStatus = false;
        }
      }
      this.model.DisplayName = x.DisplayName;
      this.model.ShowDisplayName = x.ShowDisplayName;
      this.model.CharacteristicsId = x.CharacteristicsId;

      this.model.PropertySellers = x.PropertySellers;
      this.model.PortfolioSaleOnly = this.model.Id == 0 || x.PortfolioSaleOnly == null ? false : x.PortfolioSaleOnly;
      this.model.IsPortfolio = x.IsPortfolio;
      if (x.Images) {
        if (this.IsPageLoaded == true) {
          x.Images.forEach(img => {
            const alText = 'txtalText' + (img.Id);
            const caption = 'txtCaption' + (img.Id);
            const description = 'txtLongDescription' + (img.Id);
            const displayOrder = 'txtDisplayOrder' + (img.Id);
            this.propForm.addControl(alText, new FormControl(img.AlText));
            this.propForm.addControl(caption, new FormControl(img.Caption));
            this.propForm.addControl(description, new FormControl(img.Description));
            this.propForm.addControl(displayOrder, new FormControl(img.DisplayOrder));
            this.propertyImages.push({
              Url: img.FilePath,
              Id: img.Id,
              Name: img.FilePath,
              FileContent: null,
              IsDefault: img.IsDefault,
              AlText: img.AlText,
              Caption: img.Caption,
              Description: img.Description,
              DisplayOrder: img.DisplayOrder
            });
          });
        }
      }

      if (x.Documents) {
        x.Documents.forEach(doc => {
          this.propForm.addControl('cmbDocCat' + doc.Id, new FormControl(doc.CategoryId, Validators.required));

          this.propertyDocuments.push({
            Id: doc.Id,
            Url: doc.FilePath,
            CategoryId: doc.CategoryId,
            FileContent: null,
            Name: doc.Name,
            Category: doc.Category,
            IsNew: false,
            IsDefault: false
          });
        });
      }

      if (x.InvestmentHighlights) {
        x.InvestmentHighlights.forEach(h => {
          const lastIHTitleName = 'txtIHTitle' + h.Id;
          const lastIHDescName = 'txtIHDesc' + h.Id;

          this.propForm.addControl(lastIHTitleName, new FormControl(h.Title, [Validators.required, spaceOnlyValidator]));
          this.propForm.addControl(lastIHDescName, new FormControl(h.Description));
          this.model.InvestmentHighlights.push(h);
        });
      }

      if (x.ContactOrBrokerInfo) {
        if (this.IsPageLoaded) {
          x.ContactOrBrokerInfo.forEach(b => {
            this.model.ContactOrBrokerInfo.push(b);
          });
        }
      }

      if (this.model.SPRatingId) {
        this.rating = '1';
      } else if (this.model.MoodyRatingId) {
        this.rating = '2';
      } else if (this.model.FitchRatingId) {
        this.rating = '3';
      }

      if (x.PropertySalesInputModel != undefined && x.PropertySalesInputModel.length != 0) {
        x.PropertySalesInputModel.forEach(item => {
          item.SaleDate = this.validationService.convertUTCDateToLocalDate(item.SaleDate);
          item.DateOnMarket = this.validationService.convertUTCDateToLocalDate(item.DateOnMarket);
          this.model.PropertySalesInputModel.push(item);
        })
      }

      if (x.PropertyLeasingHistoryInputModel != undefined && x.PropertyLeasingHistoryInputModel.length != 0) {
        x.PropertyLeasingHistoryInputModel.forEach(item => {
          item.Date = this.validationService.convertUTCDateToLocalDate(item.Date);
          item.LeaseCommencementDate = this.validationService.convertUTCDateToLocalDate(item.LeaseCommencementDate);
          item.LeaseExpireDate = this.validationService.convertUTCDateToLocalDate(item.LeaseExpireDate);
          item.LeaseStartDate = this.validationService.convertUTCDateToLocalDate(item.LeaseStartDate);
        })
      }

      if (this.viewSoldDetailsLink == false) {
        let CurrentPropertyStatusId = x.PropertyStatusId;
        //if (this.propertyStatusList.find(data => data.id === CurrentPropertyStatusId).description.toLowerCase() == 'sold') {
        //    this.viewSoldDetailsLink = true
        //}
      }
      this.isSPR = this.rating === '1';
      this.isMoody = this.rating === '2';
      this.isFitch = this.rating === '3';

      $('input[name="completer"]').attr('ng-reflect-model', this.model.TenantName);
      $('input[name="completer"]').val(this.model.TenantName);

      const mapProp = {
        center: new google.maps.LatLng(this.model.Latitude, this.model.Longitude),
        draggableCursor: 'auto',
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: true
      };
      this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
      this.setCenter(this.model.Latitude, this.model.Longitude, this.model.TenantTradeName);
      if (!this.model.IsPortfolio) {
        this.propertyRentTermsFielsChange();
        this.loaderService.display(false);
      }

      setTimeout(() => { this.isInitialLoad = false; }, 5000);

      this.enabeListingType = this.model.PropertyForId == 601;
      if (this.model.BrokerageId) {
        setTimeout(() => {
          let br = this.brokerageList.find(x => x.Id == this.model.BrokerageId);
          if (!br) {
            this.otherBrokerageProperty = true;
            let brk = this.allBrokerage.find(x => x.Id == this.model.BrokerageId);
            const brkrg =
            {
              Id: brk.Id,
              BrokerageName: brk.BrokerageName
            }
            this.brokerageList.push(brkrg);
          }
        }, 2000);
      }
      else {
        //this.otherBrokerageProperty = true;
      }
    });
  }
  otherBrokerageProperty = false;
  enabeListingType = false;
  setAsDefault(fileId: number, index: number) {
    for (let i = 0; i < this.propertyImages.length; i++) {
      if (this.propertyImages[i].Id === fileId) {
        this.propertyImages[i].IsDefault = true;
      } else {
        this.propertyImages[i].IsDefault = false;
      }
    }
  }

  setCenter(lat: number, lon: number, title: string) {
    this.map.setCenter(new google.maps.LatLng(lat, lon));
    const location = new google.maps.LatLng(lat, lon);

    if (!this.marker) {
      this.marker = new google.maps.Marker({
        position: location,
        map: this.map,
        title: title,
        draggable: true
      });
    } else {
      this.marker.setPosition({ lat: lat, lng: lon });
    }

    this.model.Latitude = lat;
    this.model.Longitude = lon;

    const __instance = this;
    const marker = this.marker;
    google.maps.event.addListener(marker, 'dragend', function () {
      __instance.setPropLocation(marker.getPosition());
    });
  }

  setPropLocation(x: google.maps.LatLng) {
    this.model.Latitude = x.lat();
    this.model.Longitude = x.lng();
  }

  getIhId(index: number): number {
    if (this.model.InvestmentHighlights) {
      return this.model.InvestmentHighlights[index].Id;
    }
  }

  getDocId(index: number): number {
    if (this.propertyDocuments) {
      return this.propertyDocuments[index].Id;
    }
  }
  getImageId(index: number): number {
    if (this.propertyImages) {
      return this.propertyImages[index].Id;
    }
  }

  getPropHTitleName(index: number): string {
    return 'txtIHTitle' + index;
  }

  getPropHDescriptionName(index: number): string {
    return 'txtIHDesc' + index;
  }

  convertUTCDateToLocalDate(date: any) {
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    newDate.setHours(hours - offset);

    return newDate;
  }

  onContactType($event) {
  }
  /**
  * Resets the model
  */
  resetModel() {
    this.model = {
      Id: 0,
      Guid: '00000000-0000-0000-0000-000000000000',
      LoginUserId: 0,
      TenantId: null,
      TenantTradeName: null,
      TenantName: null,
      IsFranchisee: true,
      SPRatingId: null,
      MoodyRatingId: null,
      FitchRatingId: null,
      NoOfUnits: null,
      Guarantor: 'Corporate',
      Address: null,
      StateId: null,
      CityId: null,
      Zip: null,
      BrokerList: [],
      IsFeatured: false,
      YearBuilt: null,
      Renovated: null,
      PropertyTypeId: null,
      SubCategoryId: null,
      BuildingSize: null,
      Land: null,
      PropertyForId: null,
      Description: null,
      NOI: null,
      LeasePricePSF: null,
      OriginalLeaseTerm: null,
      LeaseCommencementDate: null,
      LeaseExpiration: null,
      RentEscalationPercentage: null,
      RentEscalationPeriod: null,
      OptionNumber: null,
      OptionLength: null,
      IsShowPrice: false,
      LeaseStructureId: null,
      OwnershipTypeId: null,
      Price: null,
      PricePSF: null,
      CapRate: null,
      Latitude: null,
      Longitude: null,
      VideoUrl: null,
      DateOnMarket: new Date(),
      InvestmentHighlights: [],
      ContactOrBrokerInfo: [],
      PropertySource: null,
      PropertySalesInputModel: [],
      BrokerageId: null,
      BrokersId: [],
      LiveListingId: null,
      IsRentTermAutoCalc: true,
      PropertyRentTerm: [],
      PropertyTypeList: [],
      PropertyTypeSubcategoryList: [],
      GuarantorId: null,
      DisplayName: null,
      ShowDisplayName: true,
      CharacteristicsId: [],
      PropertyLeasingHistoryInputModel: [],
      PropertySellers: [],
      MetatagsId: [],
      UnpricedText: null,
      CapRateText: null,
      Notes: null
    };
  }
  cancelSave() {
    if (!(this.model.Guid === '00000000-0000-0000-0000-000000000000')) {
      this.onBreadCrumbClick();
    }
    else {
      this.onBreadCrumbClick();
    }
  }
  openSolidDetails(template: TemplateRef<any>, classes, StatusValue) {
    var openModelStatus = false;
    if (this.propertyStatusList.find(data => data.id === StatusValue).description.toLowerCase() == 'sold') {
      openModelStatus = true
      this.openSalesHistoryAdd('hdnSalesHistory');
    }

    if (StatusValue == 351) {
      this.model.DateOnMarket = new Date();
    }

    //if (openModelStatus) {
    //    this.viewSoldDetailsLink = true;
    //    if (this.model.BrokerageId > 0) {
    //        this.currentSalesDetails.BrokerageId = this.model.BrokerageId;
    //    }
    //    if (this.model.PropertySalesInputModel.length == 0) {
    //        this._propertyManagementService.GetSaleInfoFromOffers(this.model.Guid).subscribe(res => {
    //            
    //            if (Number(res["PropertyId"]) != 0) {
    //                this.currentSalesDetails.SaleDate = this.validationService.convertUTCDateToLocalDate(res["SaleDate"]);
    //                this.currentSalesDetails.SalePSF = Number(res["SalePrice"]) / Number(this.model.BuildingSize);
    //                this.currentSalesDetails.SaleCapRate = (Number(this.model.NOI) / Number(res["SalePrice"])) * 100;
    //                this.currentSalesDetails.SalePrice = res["SalePrice"];
    //                this.currentSalesDetails.AutoPopulated = true;
    //            }

    //            this.currentSalesDetails.NOI = this.model.NOI;
    //            this.currentSalesDetails.BuildingSize = this.model.BuildingSize;
    //            if (this.modalRef != undefined) {
    //                this.modalRef.hide();
    //            }
    //            this.modalRef = this.modalService.show(template, { class: classes });
    //        });
    //    }
    //    else {
    //        if (this.model.PropertySalesInputModel.length != 0) {
    //            this.currentSalesDetails = Object.assign({}, this.model.PropertySalesInputModel[0]);
    //        }
    //        if (this.currentSalesDetails.SaleDate != null) {
    //            this.currentSalesDetails.SaleDate = this.validationService.convertUTCDateToLocalDate(this.currentSalesDetails.SaleDate);
    //        }
    //        this.currentSalesDetails.NOI = this.model.NOI;
    //        this.currentSalesDetails.BuildingSize = this.model.BuildingSize;
    //        if (this.modalRef != undefined) {
    //            this.modalRef.hide();
    //        }
    //        this.modalRef = this.modalService.show(template, { class: classes });
    //    }

    //}
    //else {
    //    this.viewSoldDetailsLink = false;
    //}
  }
  addSalesDetails(salesDetalsValue: PropertySalesInputModel) {
    this.model.PropertySalesInputModel = [];
    this.model.PropertySalesInputModel.push({
      Id: salesDetalsValue.Id,
      PropertyId: salesDetalsValue.PropertyId,
      SaleDate: salesDetalsValue.SaleDate == null ? null : this.utcify(salesDetalsValue.SaleDate),
      SalePrice: salesDetalsValue.SalePrice,
      SaleCapRate: salesDetalsValue.SaleCapRate,
      SalePSF: salesDetalsValue.SalePSF,
      BrokerageId: salesDetalsValue.BrokerageId,
      AutoCalcCapRate: salesDetalsValue.AutoCalcCapRate,
      AutoCalcPSF: salesDetalsValue.AutoCalcPSF,
      NOI: salesDetalsValue.NOI,
      BuildingSize: salesDetalsValue.BuildingSize,
      DateOnMarket: salesDetalsValue.DateOnMarket,
      YearOnMarket: salesDetalsValue.YearOnMarket,
      MonthOnMarket: salesDetalsValue.MonthOnMarket,
      DayOnMarket: salesDetalsValue.DayOnMarket,
      AskingPrice: salesDetalsValue.AskingPrice,
      AskingCapRate: salesDetalsValue.AskingCapRate,
      DiscountToAsking: salesDetalsValue.DiscountToAsking,
      BuyerName: salesDetalsValue.BuyerName,
      BuyerBrokerageName: salesDetalsValue.BuyerBrokerageName,
      BuyerBrokerName: salesDetalsValue.BuyerBrokerName,
      SellerName: salesDetalsValue.SellerName,
      SellerBrokerageName: salesDetalsValue.SellerBrokerageName,
      SellerBrokerName: salesDetalsValue.SellerBrokerName,
      RemainingTermYear: salesDetalsValue.RemainingTermYear,
      RemainingTermMonth: salesDetalsValue.RemainingTermMonth,
      RemainingTermDay: salesDetalsValue.RemainingTermDay,
      Is1031ExchangeBuyer: salesDetalsValue.Is1031ExchangeBuyer,
      SaleCharacteristicsId: salesDetalsValue.SaleCharacteristicsId,
      AutoCalcDiscount: salesDetalsValue.AutoCalcDiscount,
      LTV: salesDetalsValue.LTV,
      InterestRate: salesDetalsValue.InterestRate,
      Amortization: salesDetalsValue.Amortization,
      Term: salesDetalsValue.Term,
      SalesNotes: salesDetalsValue.SalesNotes,
      GuarantorId: salesDetalsValue.GuarantorId,
      SPRatingId: salesDetalsValue.SPRatingId,
      MoodyRatingId: salesDetalsValue.MoodyRatingId,
      FitchRatingId: salesDetalsValue.FitchRatingId,
      LeaseStructureId: salesDetalsValue.LeaseStructureId,
      RentEscalationPercentage: salesDetalsValue.RentEscalationPercentage,
      RentEscalationPeriod: salesDetalsValue.RentEscalationPeriod,
      OptionNumber: salesDetalsValue.OptionNumber,
      OptionLength: salesDetalsValue.OptionLength,
      SalesNOI: salesDetalsValue.SalesNOI,
      BuyerBrokerageId: salesDetalsValue.BuyerBrokerageId
    });
    this.modalRef.hide();
    this.viewSoldDetailsLink = true;
  }
  remarksList = [];
  onBreadCrumbClick() {
    if (this.prevPage != null && this.prevPage != undefined) {
      let opentabValue = this.prevPage == 'My Properties' ? 2 : this.prevPage == 'Market Snapshot' ? 1 : 0;
      if (opentabValue > 0) {
        this.router.navigateByUrl("/market-snapshot?UserGuid=" + this.UserGuid + "&opentab=" + opentabValue);
      }
      else if (this.prevPage == 'Off-Market Deal Approval') {
        this.router.navigateByUrl(this.prevPageRouteLink);
      }
    }
    else {
      this.router.navigateByUrl("/market-snapshot?UserGuid=" + this.UserGuid + "&opentab=1");
    }
  }

  addBroker(brokerId: number) {

    if (brokerId != null) {
      this._brokerageManagerService.getBrokerDetails(brokerId).subscribe(response => {
        if (response != null) {
          this.brokerslist.push(response);

        }
      });
    }
  }

  getFile(imageUrl: string, filename: string) {
    this.http.get(imageUrl, { responseType: 'blob' }).subscribe(val => {
      let url = URL.createObjectURL(val);
      if (filename.indexOf('http') > -1) {
        let splitted = imageUrl.split("/");
        let name = splitted[splitted.length - 1].split("?");
        filename = name[0];
      }
      this.downloadFile(url, filename);
      URL.revokeObjectURL(url);
    });
  }

  downloadFile(url: string, fileName: string) {
    let a: any = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
  };

  isContainsIsDefault() {
    return !(this.propertyImages.filter(x => x.IsDefault == true).length > 0)
  }

  loadViewdeProperty(guid) {
    if (this.removedDocIds.length == 0 && this.removedImageIds.length == 0) {
      this.onBreadCrumbClick();
    }
  }

  propertyRentTermsFielsChange() {
    this.rentTerms.LeaseCommencementDate = this.model.LeaseCommencementDate;
    this.rentTerms.LeaseExpiration = this.model.LeaseExpiration;
    this.rentTerms.RentEscalationPercentage = this.model.RentEscalationPercentage;
    this.rentTerms.RentEscalationPeriod = this.model.RentEscalationPeriod;
    this.rentTerms.OptionNumber = this.model.OptionNumber;
    this.rentTerms.OptionLength = this.model.OptionLength;
    this.rentTerms.NetOperatingIncome = this.model.NOI;

    if (this.InitialLoad && this.model.Id > 0 && !this.isPortfolio) {
      this.child.loadRentTerm(this.model.Id)
    }
    else if (this.model.NOI != null && this.rentTerms.LeaseCommencementDate && this.rentTerms.LeaseExpiration) {
      this.child.calculateRentTerm();
    }
  }

  saveRentTerm(saveRentTerm: IPropertyRentTermModel[]) {
    this.model.PropertyRentTerm = saveRentTerm;
    this._sharedService.setPropertyRentTermValue(saveRentTerm);
  }

  updateLoadStatus(loadStatus: boolean) {
    this.InitialLoad = false;
  }

  openAutoCalcRentTermModal(template: TemplateRef<any>, classes: any, retnTermAutoCalcValue: boolean) {
    const config = {
      ignoreBackdropClick: true,
      class: 'modal-position ' + classes,
      keyboard: false,
      backdrop: true
    }
    if (!this.retnTermAutoCalcValue) {
      this.modalRef = this.modalService.show(template, config);
    }
    else {
      this.model.IsRentTermAutoCalc = !this.retnTermAutoCalcValue;
    }
  }

  //setAutoCalcRentTerm() {
  //  this.model.IsRentTermAutoCalc = true;
  //  this.retnTermAutoCalcValue = true;
  //  this.propertyRentTermsFielsChange()
  //}

  setAutoCalcRentTermPreviousValue() {
    this.retnTermAutoCalcValue = this.model.IsRentTermAutoCalc;
  }
  addRentTerm() {
    if (!this.IsRentTableVisible) {
      this.IsRentTableVisible = true;
    }
    this.child.parentCallAddRentTable();
  }
  openModelForDeleteBrocker(template: TemplateRef<any>, classes, brokerIndex: number) {
    this.brockerIndex = brokerIndex;
    this.modalRemoveBrockerRef = this.modalService.show(template, { class: classes });
  }

  ratingAgency = RatingAgency;
  onGuarantorChanges() {
    if (this.model.GuarantorId) {
      this._commonService.GetGuarantorDetails(this.model.GuarantorId).subscribe(res => {
        let rating: IGuarantorRating[] = [] = res["GuarantorRating"];
        this.resetRatingModels();
        rating.forEach(item => {
          if (item.RatingAgengyType == this.ratingAgency.SandPRating) {
            this.model.SPRatingId = item.RatingId;
          }
          else if (item.RatingAgengyType == this.ratingAgency.MoodysRating) {
            this.model.MoodyRatingId = item.RatingId;
          }
          else if (item.RatingAgengyType == this.ratingAgency.FitchRating) {
            this.model.FitchRatingId = item.RatingId;
          }
        });
      });
    }
    else {
      this.resetRatingModels();
    }
  }
  resetRatingModels() {
    this.model.SPRatingId = null;
    this.model.MoodyRatingId = null;
    this.model.FitchRatingId = null;
  }

  enableDisplayName(event) {
    this.model.ShowDisplayName = event.currentTarget.checked;
  }

  onTenantBlur(evevnt) {
    setTimeout(() => {
      if ((this.model.TenantId == null || this.model.TenantId == 0) && this.model.TenantName != null && this.model.TenantName.length > 1)
        this._toastService.addToast({
          title: 'Attention Required!',
          msg: 'The Tenant that you are trying to enter does not exist in the application. Please contact your system administrator.',
          timeout: 10000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
    }, 5000);
  }

  ///Lease History //

  savelease(leasingHistory) {
    this.leaseHistory = leasingHistory;
    this.model.PropertyLeasingHistoryInputModel = leasingHistory;
  }


  saveSaleHistory(saleHistory) {
    this.saleHistory = saleHistory;
    this.model.PropertySalesInputModel = saleHistory;
  }

  saveLeasingHIstory(leasingHistory: PropertyLeasingHistoryInputModel) {
    this.FileUpload.fileCategoryId = 0;
    this.FileUpload.id = leasingHistory.Id;
    this.FileUpload.objectId = leasingHistory.Id;
    this.FileUpload.objectTypeId = 308;
    this.FileUpload.type = "Documents";

    if (leasingHistory.SelectedFiles != null && leasingHistory.SelectedFiles != undefined && leasingHistory.SelectedFiles.length > 0) {
      let index = 0;
      leasingHistory.SelectedFiles.forEach(item => {
        this.FileUpload.documentName = item["name"];
        var data = [];
        data.push(item);
        this._fileUploadService.uploadFiles(this.FileUpload, data).subscribe(response => {
          this.docUploadIndex.next(this.UploadIndex - 1);
          this.UploadIndex = this.UploadIndex - 1;
        });
      });
    }
  }

  savePropertySaleHistory(saleHistory: PropertySalesInputModel) {
    this.FileUpload.fileCategoryId = 0;
    this.FileUpload.id = saleHistory.Id;
    this.FileUpload.objectId = saleHistory.Id;
    this.FileUpload.objectTypeId = 310;
    this.FileUpload.type = "Documents";

    if (saleHistory.SelectedFiles != null && saleHistory.SelectedFiles != undefined && saleHistory.SelectedFiles.length > 0) {
      let index = 0;
      saleHistory.SelectedFiles.forEach(item => {
        this.FileUpload.documentName = item["name"];
        var data = [];
        data.push(item);
        this._fileUploadService.uploadFiles(this.FileUpload, data).subscribe(response => {
          this.docUploadIndex.next(this.UploadIndex - 1);
          this.UploadIndex = this.UploadIndex - 1;
        });
      });
    }
  }

  uploadLeaseHistoryFiles(LeasingHistory: PropertyLeasingHistoryInputModel): Observable<any>[] {
    LeasingHistory.Documents.forEach(doc => {
      if (doc.FileContent === null) {
        return;
      }

      this.uploadedFiles.push({
        id: doc.Id,
        objectId: LeasingHistory.Id,
        type: 'Documents',
        documentName: doc.Name,
        fileCategoryId: 0,//doc.CategoryId,
        objectTypeId: 308,// leasing history
        FileContent: doc.FileContent
      });
    });

    const fileUploadResponses: Observable<any>[] = [];
    this.uploadedFiles.forEach(file => {
      const status = this._fileUploadService.uploadFile(file);
      fileUploadResponses.push(status);
    });

    return fileUploadResponses;
  }
  ///Lease History ends//

  openSalesHistoryAdd(id) {
    this.disableAddEditHistoryButton = true;
    $('#' + id).click();
  }

  componentFormCustomer_US = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
  }
  googleCity: string = '';

  fillInAddress(place: Object) {
    this.model.StateId = null;
    this.model.CityId = null;
    this.isPlacesApi = true;
    this.PlacesLat = place["geometry"].location.lat();
    this.PlacesLong = place["geometry"].location.lng();
    var localval, streetval = '';
    var that = this;
    let noPostCode = true;
    let noState = true;
    this.model.Address = "";
    for (var i = 0; i < place['address_components'].length; i++) {
      var addressType = place['address_components'][i].types[0];
      if (this.componentFormCustomer_US[addressType]) {
        var val = place['address_components'][i][this.componentFormCustomer_US[addressType]];
        if (addressType == 'street_number') {
          streetval = val;
        }
        else if (addressType == 'route') {
          this.model.Address = streetval + ' ' + val;
          that.propForm.controls['txtAddress'].setValue(streetval + ' ' + val);
          that.propForm.get('txtAddress').updateValueAndValidity();
        }
        else if (addressType == 'locality' || addressType == 'administrative_area_level_3') {
          localval = val;
          this.googleCity = val.toLowerCase()
        }
        else if (addressType == 'administrative_area_level_1') {
          this.statesList.forEach(item => {
            if (item.Name.toLowerCase() == val.toLowerCase()) {
              that.model.StateId == item.Id;
              that.bindGoogleCityAndState(item.Id, this.googleCity);
              noState = false;
            }
          });
        }
        else if (addressType == 'postal_code') {
          this.model.Zip = val;
          noPostCode = false;
        }
      }
    }
    this.callZipChange(1);
    setTimeout(() => { that._ChangeDetectorRef.detectChanges(); }, 500);

    if (noPostCode) {
      this.model.Zip = '';
      this.propForm.get('txtZip').updateValueAndValidity();
      this.cdRef.detectChanges();
    }

    if (noState) {
      this.model.StateId = null;
      this.model.CityId = null;
      this.citiesList = [];
    }
  }

  bindGoogleCityAndState(stateId, city) {
    const that = this;
    this.model.StateId = stateId;
    if (this.googleCity != '') {
      this.citiesList = [];
      this._commonService.getCitiesList(stateId).subscribe(response => {
        this.citiesList = response.map(o => {
          return { Id: o.Id, Name: o.CityName };
        });

        this.bindGoogleCity(response.filter(x => x.CityName.toLowerCase() == city.toLowerCase())[0].Id);
      });

      this.googleCity = '';
    }
  }

  bindGoogleCity(cityID) {
    this.model.CityId = cityID
    this.cdRef.detectChanges();
  }

  disableButton() {
    this.disableAddEditHistoryButton = false;
  }

  addOrRemoveValidateion(isAdd) {
    if (isAdd) {
      this.propForm.get('txtAddress').setValidators([Validators.required, spaceOnlyValidator])
      this.propForm.get('txtAddress').updateValueAndValidity();
      this.propForm.get('lstState').setValidators([Validators.required])
      this.propForm.get('lstState').updateValueAndValidity();
      this.propForm.get('lstCity').setValidators([Validators.required])
      this.propForm.get('lstCity').updateValueAndValidity();
      this.propForm.get('txtZip').setValidators([Validators.required])
      this.propForm.get('txtZip').updateValueAndValidity();
      this.propForm.get('txtYearBuilt').setValidators([Validators.required, Validators.min(1850)])
      this.propForm.get('txtYearBuilt').updateValueAndValidity();
      this.propForm.get('lstPropertyType').setValidators([Validators.required])
      this.propForm.get('lstPropertyType').updateValueAndValidity();
      this.propForm.get('lstSubcatgeories').setValidators([this.model.PropertyStatusId == 6906 ? Validators.required : defaultValidator])
      this.propForm.get('lstSubcatgeories').updateValueAndValidity();
      this.propForm.get('txtland').setValidators([this.model.PropertyStatusId == 6906 ? Validators.required : defaultValidator])
      this.propForm.get('txtland').updateValueAndValidity();
      this.propForm.get('txtBuildingSF').setValidators([Validators.required, Validators.min(1)])
      this.propForm.get('txtBuildingSF').updateValueAndValidity();
      this.propForm.get('txtNOI').setValidators([Validators.required, Validators.min(0)])
      this.propForm.get('txtNOI').updateValueAndValidity();
      this.propForm.get('txtPSF').setValidators([this.isPropertyForSale && this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator, this.isPropertyForSale ? Validators.min(0) : defaultValidator])
      this.propForm.get('txtPSF').updateValueAndValidity();
      this.propForm.get('txtCommencement').setValidators([Validators.required, minimumYearValidator(() => this.builtYear)])
      this.propForm.get('txtCommencement').updateValueAndValidity();
      this.propForm.get('txtExpiration').setValidators([Validators.required, Validators.min(this.model.YearBuilt), minimumDateValidator(() => this.model.LeaseCommencementDate)])
      this.propForm.get('txtExpiration').updateValueAndValidity();
      this.propForm.get('lstLeaseStructure').setValidators([Validators.required])
      this.propForm.get('lstLeaseStructure').updateValueAndValidity();
      this.propForm.get('lstOwnershipType').setValidators([Validators.required])
      this.propForm.get('lstOwnershipType').updateValueAndValidity();
      if (!this.model.Unpriced) {
        this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator]);
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      else {
        this.propForm.get('txtAskingPrice').clearValidators();
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
    }
    else {
      this.propForm.get('txtAddress').clearValidators()
      this.propForm.get('txtAddress').updateValueAndValidity();
      this.propForm.get('lstState').clearValidators()
      this.propForm.get('lstState').updateValueAndValidity();
      this.propForm.get('lstCity').clearValidators()
      this.propForm.get('lstCity').updateValueAndValidity();
      this.propForm.get('txtZip').clearValidators()
      this.propForm.get('txtZip').updateValueAndValidity();
      this.propForm.get('txtYearBuilt').clearValidators()
      this.propForm.get('txtYearBuilt').updateValueAndValidity();
      this.propForm.get('lstPropertyType').clearValidators()
      this.propForm.get('lstPropertyType').updateValueAndValidity();
      this.propForm.get('txtBuildingSF').clearValidators()
      this.propForm.get('txtBuildingSF').updateValueAndValidity();
      this.propForm.get('lstPropertyFor').clearValidators()
      this.propForm.get('lstPropertyFor').updateValueAndValidity();
      this.propForm.get('txtNOI').clearValidators()
      this.propForm.get('txtNOI').updateValueAndValidity();
      this.propForm.get('txtPSF').clearValidators()
      this.propForm.get('txtPSF').updateValueAndValidity();
      this.propForm.get('txtCommencement').clearValidators()
      this.propForm.get('txtCommencement').updateValueAndValidity();
      this.propForm.get('txtExpiration').clearValidators()
      this.propForm.get('txtExpiration').updateValueAndValidity();
      this.propForm.get('lstLeaseStructure').clearValidators()
      this.propForm.get('lstLeaseStructure').updateValueAndValidity();
      this.propForm.get('lstOwnershipType').clearValidators()
      this.propForm.get('lstOwnershipType').updateValueAndValidity();
      this.propForm.get('txtDisplayName').clearValidators()
      this.propForm.get('txtDisplayName').updateValueAndValidity();

      if (!this.model.Unpriced) {
        this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator]);
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      else {
        this.propForm.get('txtAskingPrice').clearValidators();
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
    }
  }

  //-- add seller to property Start here
  modalRefSeller: BsModalRef;
  selectedUserId = [];
  openModalForSeller(template: TemplateRef<any>, classes) {
    this.selectedUserId = [];
    this.selectedUserId = this.model.PropertySellers.map(o => o.Id);
    this.modalRefSeller = this.modalService.show(template, { class: classes });
  }

  addSeller(seller) {
    const sellerInfo = {
      Id: seller.Id,
      Name: seller.Name,
      Phone: seller.Phone,
      Email: seller.Email,
    }
    if (this.model.PropertySellers.findIndex(x => x.Id == sellerInfo.Id) < 0) {
      this.model.PropertySellers.push(sellerInfo);
    }
  }

  onRemoveSeller(index: number) {
    this.model.PropertySellers.splice(index, 1);
  }

  //-- add seller to property Ends here

  bindAutoCalc(type, isChacked, isInitialLoad = false) {
    if (!isInitialLoad) {
      if (type == 9 && !this.isInitialLoad && (isChacked && this.model.AutoCalcLeaseExpiration)) {
        this.model.AutoCalcLeaseExpiration = false;
        this.cdRef.detectChanges();
      }
      if (type == 8 && !this.isInitialLoad && (isChacked && this.model.AutoCalcCommencement)) {
        this.model.AutoCalcCommencement = false;
        this.cdRef.detectChanges();
      }
      if (type == 3 && !this.isInitialLoad && (isChacked && this.model.AutoCalcPortfolioType)) {
        this.model.AutoCalcPortfolioType = false;
        this.cdRef.detectChanges();
      }

      if (type == 4 && !this.isInitialLoad && (isChacked && this.model.AutoCalcPortfolioSubcategory)) {
        this.model.AutoCalcPortfolioSubcategory = false;
        this.cdRef.detectChanges();
      }
      if (type == 5 && !this.isInitialLoad && (isChacked && this.model.AutoCalcOwnershipType)) {
        this.model.AutoCalcOwnershipType = false;
        this.cdRef.detectChanges();
      }
      if (type == 11 && !this.isInitialLoad && (isChacked && this.model.AutoCalcLeaseType)) {
        this.model.AutoCalcLeaseType = false;
        this.cdRef.detectChanges();
      }
      if (type == 12 && !this.isInitialLoad && (isChacked && this.model.AutoCalcTenantType)) {
        this.model.AutoCalcTenantType = false;
        this.cdRef.detectChanges();
      }
    }
  }

  propertySearchCriteria = {} as IPropertySearchCriteria;
  loadPortfolioProperties() {
    this.loaderService.display(true);
    this.propertySearchCriteria.PropertyId = this.model.Id;
    this._propertyListingService.GetDataentryPortfolioPropertiesList(this.propertySearchCriteria).subscribe(item => {
      this.portfolioSelectedProperties = item;
      this._sharedService.setPortfolioProperties(item);
      this.loaderService.display(false);
    });
  }

  autoCalcAllFileds() {
    for (let i = 1; i <= 14; i++) {
      this.autoCalcFields(i, null);
    }
  }

  autoCalcFields(type, isChecked) {
    if (isChecked) {
      this.isInitialLoad = true;
      let portfolioProperties
      this._sharedService.portfolioPropertiesChange.subscribe(item => {
        portfolioProperties = item
      });

      switch (type) {
        case 1: // Number Of Locations
          if (isChecked == true || (isChecked == null && this.model.AutoCalcNumberOfLocations)) {
            let location = portfolioProperties.map(x => { return { state: x.State, city: x.City } });
            let distinctLocations = location.filter((thing, index, self) =>
              index === self.findIndex((t) => (
                t.state === thing.state && t.city === thing.city
              ))
            )
            this.model.NumberOfLocations = distinctLocations.length;
          }
          break;
        case 2: // Number Of Properties
          if (isChecked == true || (isChecked == null && this.model.AutoCalcNumberOfProperties)) {
            this.model.NumberOfProperties = portfolioProperties.length;
          }
          break;
        case 3: //  Portfolio Type                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcPortfolioType)) {
            this.model.PropertyTypeList = Array.from(new Set(portfolioProperties.flatMap(x => x.PropertyTypeIds)));
          }
          break;
        case 4: //   Portfolio Subcategory                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcPortfolioSubcategory)) {
            this.model.PropertyTypeSubcategoryList = Array.from(new Set(portfolioProperties.flatMap(x => x.PropertyTypeSubcategoryIds)));
          }
          break;
        case 5: //         Ownership Type                   
          if (isChecked == true || (isChecked == null && this.model.AutoCalcOwnershipType)) {
            this.model.OwnershipTypeIds = Array.from(new Set(portfolioProperties.flatMap(x => x.OwnershipTypeId)));
          }
          break;
        case 6: //        RENT / NOI                    
          if ((isChecked == true || (isChecked == null && this.model.AutoCalcRent)) && !this.model.OnlyZCF) {
            let noi = portfolioProperties.map(x => x.RentNOI);
            this.model.NOI = this.findArrayAverageOrSum(noi, 1);

            this.updateCapRate('NOI')
            //let totalNoi = portfolioProperties.map(x => x.RentNOI).reduce((a, b) => a + b, 0);
            //portfolioProperties.forEach(x => {
            //    x.RentWeight = (x.RentNOI / totalNoi) * 100;
            //})
            //portfolioProperties.forEach(x => {
            //    x.Remainingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)) / 365),
            //    x.WeightedRemaingterm = ((this.validationService.DateDiff(new Date(), new Date(x.LeaseExpiration))) / 365) * (x.RentWeight / 100)
            //})

            //let noi = portfolioProperties.map(x => x.WeightedRemaingterm);
            //this.model.NOI = this.findArrayAverageOrSum(noi, 1);
          }
          break;
        case 7: //         Original Lease Term                   
          if (isChecked == true || (isChecked == null && this.model.AutoCalcOriginalLeaseTerm)) {
            let originalLeaseTerm = portfolioProperties.map(x => this.validationService.DateDiff(this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)));
            let avgOriginalLeaseTerm = this.findArrayAverageOrSum(originalLeaseTerm, 4);
            this.model.PortfolioOriginalLeaseTerm = this.convertDaysToDate(avgOriginalLeaseTerm);
          }
          break;
        case 8: //         Commencement                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcCommencement)) {
            let leaseCommencementDate = portfolioProperties.map(x => this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate));
            this.model.LeaseCommencementDate = this.findArrayAverageOrSum(leaseCommencementDate, 2);
          }
          break;
        case 9: //         Lease Expiration                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcLeaseExpiration)) {
            let leaseExpiration = portfolioProperties.map(x => this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration));
            this.model.LeaseExpiration = this.findArrayAverageOrSum(leaseExpiration, 3);
          }
          break;
        case 10: //           Remaining Lease Term                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcRemainingLeaseTerm)) {
            //let remainingLeaseTerm = portfolioProperties.map(x => this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)));
            //let avgRemainingLeaseTerm = this.findArrayAverageOrSum(remainingLeaseTerm, 4);
            //this.model.PortfolioRemainingLeaseTerm = this.convertDaysToDate(avgRemainingLeaseTerm);

            //portfolioProperties.forEach(x => {
            //    x.Remainingterm = ((this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration))) / 365)                        
            //})
            //let remainingLeaseTerm = portfolioProperties.map(x => x.Remainingterm)
            //let avgRemainingLeaseTerm = this.findArrayAverageOrSum(remainingLeaseTerm, 4);
            //this.model.PortfolioRemainingLeaseTerm = this.convertDaysToDateWithDecimal(avgRemainingLeaseTerm);

            let totalNoi = portfolioProperties.filter(x => x.RemainingTerm > 0).map(x => x.RentNOI).reduce((a, b) => a + b, 0);
            portfolioProperties.forEach(x => {
              x.RentWeight = (x.RentNOI / totalNoi) * 100;
            })
            portfolioProperties.forEach(x => {
              //x.Remainingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)) / 365),
              // x.WeightedRemaingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration))) * (x.RentWeight / 100)
              x.YEARFRAC = x.RemainingTerm <= 0 ? 0 : this._commonService.YEARFRAC((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration), 0)
              x.WeightedRemaingterm = x.YEARFRAC * (x.RentWeight / 100)
            })

            let noi = portfolioProperties.map(x => x.WeightedRemaingterm);
            var date = this.convertDaysAndMonthFromDate(this.findArrayAverageOrSum(noi, 1));
            var data = date.split("|");
            if (!isNaN(Number(data[0])))
              this.model.PortfolioRemainingLeaseTermYear = Number(data[0]);

            if (!isNaN(Number(data[1])))
              this.model.PortfolioRemainingLeaseTermMonth = Number(data[1]);

            this.model.PortfolioRemainingLeaseTerm = this.convertDaysToDateWithDecimal(this.findArrayAverageOrSum(noi, 1));
          }
          break;
        case 11: //   Lease Type                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcLeaseType)) {
            this.model.LeaseStructureIds = Array.from(new Set(portfolioProperties.flatMap(x => x.LeaseStructureId)));
          }
          break;
        case 12: //    Rental Increase                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcRentalIncrease)) {
            let rentEscalationPercentage = portfolioProperties.map(x => x.RentEscalationPercentage);
            this.model.RentEscalationPercentage = this.findArrayAverageOrSum(rentEscalationPercentage, 4);
          }
          break;
        case 13: //   Option Number                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcOptionNumber)) {
            let optionNumber = portfolioProperties.map(x => x.OptionNumber);
            this.model.OptionNumber = Math.round(this.findArrayAverageOrSum(optionNumber, 4));
          }
          break;
        case 14: //   Length Length                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcOptionNumber)) {
            let optionLength = portfolioProperties.map(x => x.OptionLength);
            this.model.OptionLength = Math.round(this.findArrayAverageOrSum(optionLength, 4));
          }
          break;
        case 15: //   Length Length                    
          if (isChecked == true || (isChecked == null && this.model.AutoCalcTenantType)) {
            let isTenantAutoPopulate = Array.from(new Set(portfolioProperties.flatMap(x => x.TenantId))).length == 1 ? true : false;
            this.model.TenantTypeId = isTenantAutoPopulate ? 4001 : 4002; //single tenant : multi tenant                    
          }
          break;
        case 16: //  Land               
          if (isChecked == true || (isChecked == null && this.model.AutoCalcLand)) {
            let isLandAtoCalc = portfolioProperties.map(x => x.Land);
            this.model.Land = this.findArrayAverageOrSum(isLandAtoCalc, 1)
          }
          break;
        case 17: //  BuildingSize               
          if (isChecked == true || (isChecked == null && this.model.AutoCalcLand)) {
            let BuildingSize = portfolioProperties.map(x => x.BuildingSize);
            this.model.BuildingSize = this.findArrayAverageOrSum(BuildingSize, 1)
            this.updatePSF();
          }
          break;
      }
      //this.propForm.patchValue(this.model.PropertyTypeList, { emitEvent: true });     
      //setTimeout(() => {
      this.isInitialLoad = false;
      //}, 100);
    }
  }

  onPortfolioPropertyForChanged(event) {
    if (this.model.PropertyForId === 601) {
      this.propertyFor = "B+E Listing";
      this.propertyStatusList = this.propertyStatusList_All.map(o => {
        return {
          id: o.id, description: o.description
        };
      });
    }
    else {
      this.propertyFor = "1031 Trade";
      this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 349), 1);
      this.propertyStatusList.splice(this.propertyStatusList.findIndex(x => x.id == 350), 1);
      if (this.model.PropertyStatusId == 349 || this.model.PropertyStatusId == 350) {
        this.model.PropertyStatusId = 351;
      }
    }
  }

  calcPrice(isCalc) {
    if (isCalc && this.isPortfolio) {
      let price = this.portfolioSelectedProperties.map(x => x.Price);
      this.model.Price = this.findArrayAverageOrSum(price, 1);
      this.reCalcRates(1, this.model.AutoCalcPSF);
      this.reCalcRates(2, this.model.AutoCalcCapRate);
    }
  }

  findArrayAverageOrSum(array, type = 0) {
    if (array.length > 0) {
      if (type == 1) { //sum 
        return array.reduce((a, b) => (a > 0 ? a : 0) + (b > 0 ? b : 0), 0);
      }
      else if (type == 2) { // min
        return array.reduce((a, b) => a < b ? a : b);
      }
      else if (type == 3) { // max
        return array.reduce((a, b) => a > b ? a : b);
      }
      else if (type == 4) { // average
        return array.reduce((a, b) => a + b, 0) / array.length;
      }
      else {
        return null
      }
    }
    else {
      return null;
    }
  }

  convertDaysToDateWithDecimal(number) {
    try {
      let value = number.toFixed(1);
      let date = value.toString().split('.');
      let months = parseInt(((date[1] / 10) * 12).toString().split('.')[0]);
      return (parseInt(date[0]) > 0 ? date[0] + ' Years ' + (months > 0 ? "& " : "") : "") + (months > 0 ? + months + ' Months' : "");
    }
    catch { }
    return "";
  }

  convertDaysAndMonthFromDate(number) {
    try {
      let value = number.toFixed(1);
      let date = value.toString().split('.');
      let months = parseInt(((date[1] / 10) * 12).toString().split('.')[0]);
      return (parseInt(date[0]) > 0 ? date[0] + '' + (months > 0 ? "|" : "") : "") + (months > 0 ? + months : "");
    }
    catch { }
    return "";
  }

  convertDaysToDate(numberOfDays) {
    let years = parseInt((numberOfDays / 365).toFixed());
    let months = parseInt(((numberOfDays % 365) / 30).toFixed());
    let ndays = parseInt(((numberOfDays % 365) % 30).toFixed());
    const yrs = years > 1 ? 'Years' : 'Year';
    const mnts = months > 1 ? 'Months' : 'Month';
    const days = ndays > 1 ? 'days' : 'day';
    if (months >= 12) {
      years = years + 1;
      months = 0;
    }

    if (years === 0 && months > 0) {
      return months + ' ' + mnts;
    }
    if (months > 0) {
      return years + ' ' + yrs + ' & ' + months + ' ' + mnts;
    }
    else if ((years < 1 && months < 1) || (years === 0 && months === 0)) {
      if (years === 0 && months === 0 && ndays > 0) {
        return ndays + ' ' + days;
      }
      return 'Expired';
    }
    return years + ' ' + yrs;
  }

  addOrRemoveValidateionForPortfolio(isAdd) {
    if (isAdd) {
      //this.propForm.get('txtTenantName').setValidators([Validators.required, spaceOnlyValidator])
      //this.propForm.get('txtTenantName').updateValueAndValidity();

      this.propForm.get('txtAddress').setValidators([Validators.required, spaceOnlyValidator])
      this.propForm.get('txtAddress').updateValueAndValidity();
      this.propForm.get('lstState').setValidators([Validators.required])
      this.propForm.get('lstState').updateValueAndValidity();
      this.propForm.get('lstCity').setValidators([Validators.required])
      this.propForm.get('lstCity').updateValueAndValidity();
      this.propForm.get('txtZip').setValidators([Validators.required])
      this.propForm.get('txtZip').updateValueAndValidity();
      this.propForm.get('txtYearBuilt').setValidators([Validators.required, Validators.min(1850)])
      this.propForm.get('txtYearBuilt').updateValueAndValidity();
      this.propForm.get('lstPropertyType').setValidators([Validators.required])
      this.propForm.get('lstPropertyType').updateValueAndValidity();
      this.propForm.get('txtBuildingSF').setValidators([Validators.required, Validators.min(1)])
      this.propForm.get('txtBuildingSF').updateValueAndValidity();
      this.propForm.get('txtNOI').setValidators([Validators.required, Validators.min(0)])
      this.propForm.get('txtNOI').updateValueAndValidity();
      this.propForm.get('txtPSF').setValidators([this.isPropertyForSale ? Validators.required : defaultValidator, this.isPropertyForSale ? Validators.min(0) : defaultValidator])
      this.propForm.get('txtPSF').updateValueAndValidity();
      this.propForm.get('txtCommencement').setValidators([Validators.required, minimumYearValidator(() => this.builtYear)])
      this.propForm.get('txtCommencement').updateValueAndValidity();
      this.propForm.get('txtExpiration').setValidators([Validators.required, Validators.min(this.model.YearBuilt), minimumDateValidator(() => this.model.LeaseCommencementDate)])
      this.propForm.get('txtExpiration').updateValueAndValidity();
      this.propForm.get('lstLeaseStructure').setValidators([Validators.required])
      this.propForm.get('lstLeaseStructure').updateValueAndValidity();
      this.propForm.get('lstOwnershipType').setValidators([Validators.required])
      this.propForm.get('lstOwnershipType').updateValueAndValidity();
      if (!this.model.Unpriced) {
        this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator])
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      else {
        this.propForm.get('txtAskingPrice').clearValidators();
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      this.propForm.get('txtOriginal').disable()
      this.propForm.get('txtOriginal').updateValueAndValidity();
      this.propForm.get('txtland').setValidators([this.model.PropertyStatusId == 6906 ? Validators.required : defaultValidator, Validators.min(0.001)])
    }
    else {
      this.propForm.get('txtland').clearValidators()
      this.propForm.get('txtland').updateValueAndValidity();
      //this.propForm.get('txtTenantName').clearValidators()
      //this.propForm.get('txtTenantName').updateValueAndValidity();
      this.propForm.get('txtAddress').clearValidators()
      this.propForm.get('txtAddress').updateValueAndValidity();
      this.propForm.get('lstState').clearValidators()
      this.propForm.get('lstState').updateValueAndValidity();
      this.propForm.get('lstCity').clearValidators()
      this.propForm.get('lstCity').updateValueAndValidity();
      this.propForm.get('txtZip').clearValidators()
      this.propForm.get('txtZip').updateValueAndValidity();
      this.propForm.get('txtYearBuilt').clearValidators()
      this.propForm.get('txtYearBuilt').updateValueAndValidity();
      this.propForm.get('lstPropertyType').clearValidators()
      this.propForm.get('lstPropertyType').updateValueAndValidity();
      this.propForm.get('txtBuildingSF').clearValidators()
      this.propForm.get('txtBuildingSF').updateValueAndValidity();
      this.propForm.get('txtNOI').clearValidators()
      this.propForm.get('txtNOI').updateValueAndValidity();
      this.propForm.get('txtPSF').clearValidators()
      this.propForm.get('txtPSF').updateValueAndValidity();
      this.propForm.get('txtCommencement').clearValidators()
      this.propForm.get('txtCommencement').updateValueAndValidity();
      this.propForm.get('txtExpiration').clearValidators()
      this.propForm.get('txtExpiration').updateValueAndValidity();
      this.propForm.get('lstLeaseStructure').clearValidators()
      this.propForm.get('lstLeaseStructure').updateValueAndValidity();
      this.propForm.get('lstOwnershipType').clearValidators()
      this.propForm.get('lstOwnershipType').updateValueAndValidity();


      if (!this.model.Unpriced) {
        this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator])
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      else {
        this.propForm.get('txtAskingPrice').clearValidators();
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
    }
  }

  suggested = [];
  viewSuggestProperties(template: TemplateRef<any>, classes: any) {
    this.suggested = this.portfolioSelectedProperties.map(item => item.Id);
    this.modalSuggestedPropertyRef = this.modalService.show(template, { class: classes });
  }

  onClose(event) {
    if (close) {
      this.modalSuggestedPropertyRef.hide();
    }
  }

  selectedProperties(event) {

    event.forEach(item => {
      this.portfolioSelectedProperties.push(item);
    })
    this._sharedService.setPortfolioProperties(this.portfolioSelectedProperties);
    this.propertyForDisabled = this.portfolioSelectedProperties.filter(x => parseInt(x.PropertyForId) == 602).length > 0 ? true : false;
    this.cdRef.detectChanges();
  }

  openRemovePortfolioProperty(index) {
    this.portfolioSelectedProperties.splice(index, 1);
    this._sharedService.setPortfolioProperties(this.portfolioSelectedProperties)
    this.propertyForDisabled = this.portfolioSelectedProperties.filter(x => parseInt(x.PropertyForId) == 602).length > 0 ? true : false;
    this.cdRef.detectChanges();
  }
  portfolioOninit() {
    this.addOrRemoveValidateionForPortfolio(false);
    this.propForm.get('txtOriginal').enable();
    this.model.IsPortfolio = this.isPortfolio;
    this.model.ShowDisplayName = true;
    this.model.PropertyForId = 601; // B+E listing
    this.model.IsComp = false;
    this.model.IsArchive = false;
    this.model.AutoCalcPrice = true;
    this.model.PropertyRentTerm = [];

    this._sharedService.portfolioPropertiesChange.subscribe(item => {

      this.propertyForDisabled = this.portfolioSelectedProperties.filter(x => parseInt(x.PropertyForId) == 602).length > 0 ? true : false;
      ////this.autoPopulate = false;
      ////this.modelAutoPopulateWarning = this.modalService.show(this.AutoPopulateWarning, { class: 'deletemodal' });
      let portfolioProperties = item
      let price = portfolioProperties.map(x => x.Price);

      if (this.model.AutoCalcBuildingSize) {
        let BuildingSize = portfolioProperties.map(x => x.BuildingSize);
        this.model.BuildingSize = this.findArrayAverageOrSum(BuildingSize, 1);
      }

      if (this.model.AutoCalcPrice) {
        this.model.Price = this.findArrayAverageOrSum(price, 1);
      }

      if (this.model.AutoCalcNumberOfLocations) {
        let location = portfolioProperties.map(x => { return { state: x.State, city: x.City } });
        let distinctLocations = location.filter((thing, index, self) =>
          index === self.findIndex((t) => (
            t.state === thing.state && t.city === thing.city
          ))
        )
        this.model.NumberOfLocations = distinctLocations.length;
      }
      if (this.model.AutoCalcNumberOfProperties) {
        this.model.NumberOfProperties = portfolioProperties.length;
      }
      if (this.model.AutoCalcRent) {

        let noi = portfolioProperties.map(x => x.RentNOI);
        this.model.NOI = this.findArrayAverageOrSum(noi, 1);
        //let totalNoi = portfolioProperties.map(x => x.RentNOI).reduce((a, b) => a + b, 0);
        //portfolioProperties.forEach(x => {
        //    x.RentWeight = (x.RentNOI / totalNoi) * 100;
        //})
        //portfolioProperties.forEach(x => {
        //    x.Remainingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)) / 365),
        //    x.WeightedRemaingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)) / 365) * (x.RentWeight / 100)
        //})

        //let noi = portfolioProperties.map(x => x.WeightedRemaingterm);
        //this.model.NOI = this.findArrayAverageOrSum(noi, 1);

      }
      if (this.model.AutoCalcOriginalLeaseTerm) {
        let originalLeaseTerm = portfolioProperties.map(x => this.validationService.DateDiff(this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)));
        let avgOriginalLeaseTerm = this.findArrayAverageOrSum(originalLeaseTerm, 4);
        this.model.PortfolioOriginalLeaseTerm = this.convertDaysToDate(avgOriginalLeaseTerm);
      }
      if (this.model.AutoCalcRentalIncrease) {
        let rentEscalationPercentage = portfolioProperties.map(x => x.RentEscalationPercentage);
        this.model.RentEscalationPercentage = this.findArrayAverageOrSum(rentEscalationPercentage, 4);
      }
      if (this.model.AutoCalcOptionNumber) {
        let optionNumber = portfolioProperties.map(x => x.OptionNumber);
        this.model.OptionNumber = Math.round(this.findArrayAverageOrSum(optionNumber, 4));
      }
      if (this.model.AutoCalcOptionNumber) {
        let optionLength = portfolioProperties.map(x => x.OptionLength);
        this.model.OptionLength = Math.round(this.findArrayAverageOrSum(optionLength, 4));
      }
      if (this.model.AutoCalcRemainingLeaseTerm) {

        let totalNoi = portfolioProperties.filter(x => x.RemainingTerm > 0).map(x => x.RentNOI).reduce((a, b) => a + b, 0);
        portfolioProperties.forEach(x => {
          x.RentWeight = (x.RentNOI / totalNoi) * 100;
        })
        portfolioProperties.forEach(x => {
          //x.Remainingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration)) / 365),
          // x.WeightedRemaingterm = (this.validationService.DateDiff((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration))) * (x.RentWeight / 100)
          x.YEARFRAC = x.RemainingTerm <= 0 ? 0 : this._commonService.YEARFRAC((this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) > new Date() ? this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate) : new Date()), this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration), 0)
          x.WeightedRemaingterm = x.YEARFRAC * (x.RentWeight / 100)
        })

        let noi = portfolioProperties.map(x => x.WeightedRemaingterm);
        var date = this.convertDaysAndMonthFromDate(this.findArrayAverageOrSum(noi, 1));
        var data = date.split("|");
        if (!isNaN(Number(data[0])))
          this.model.PortfolioRemainingLeaseTermYear = Number(data[0]);

        if (!isNaN(Number(data[1])))
          this.model.PortfolioRemainingLeaseTermMonth = Number(data[1]);

        this.model.PortfolioRemainingLeaseTerm = this.convertDaysToDateWithDecimal(this.findArrayAverageOrSum(noi, 1));
      }
      if (this.model.AutoCalcTenantType) {
        let isTenantAutoPopulate = Array.from(new Set(item["flatMap"](x => x.TenantId))).length == 1 ? true : false;
        this.model.TenantTypeId = isTenantAutoPopulate ? 4001 : 4002; //single tenant : multi tenant             
      }
      if (this.model.AutoCalcLand) {
        let isLandAtoCalc = portfolioProperties.map(x => x.Land);
        this.model.Land = this.findArrayAverageOrSum(isLandAtoCalc, 1);
      }


      this.reCalcRates(1, this.model.AutoCalcPSF);
      this.reCalcRates(2, this.model.AutoCalcCapRate);


      if (!this.isInitialLoad) {
        this.isInitialLoad = true;

        if (this.model.AutoCalcPortfolioType) {
          this.model.PropertyTypeList = Array.from(new Set(portfolioProperties["flatMap"](x => x.PropertyTypeIds)));
        }
        if (this.model.AutoCalcPortfolioSubcategory) {
          this.model.PropertyTypeSubcategoryList = Array.from(new Set(portfolioProperties["flatMap"](x => x.PropertyTypeSubcategoryIds)));
        }
        if (this.model.AutoCalcOwnershipType) {
          this.model.OwnershipTypeIds = Array.from(new Set(portfolioProperties["flatMap"](x => x.OwnershipTypeId)));
        }
        if (this.model.AutoCalcCommencement) {
          let leaseCommencementDate = portfolioProperties.map(x => this.validationService.convertUTCDateToLocalDate(x.LeaseCommencementDate));
          this.model.LeaseCommencementDate = this.findArrayAverageOrSum(leaseCommencementDate, 2);
        }
        if (this.model.AutoCalcLeaseExpiration) {
          let leaseExpiration = portfolioProperties.map(x => this.validationService.convertUTCDateToLocalDate(x.LeaseExpiration));
          this.model.LeaseExpiration = this.findArrayAverageOrSum(leaseExpiration, 3);
        }
        if (this.model.AutoCalcLeaseType) {
          this.model.LeaseStructureIds = Array.from(new Set(portfolioProperties["flatMap"](x => x.LeaseStructureId)));
        }

        setTimeout(() => {
          this.isInitialLoad = false;
        }, 100)
      }
    });

  }


  //-- Property duplicate checking Start
  ShowDuplicates = false;
  duplicatePropertyList = [];
  onDuplicateChecking() {
    this.duplicatesFound = false;
    this.ShowDuplicates = false;
    //if (this.validationService.IsValid(this.model.CityId) && this.validationService.IsValid(this.model.StateId) && this.validationService.IsValid(this.model.Zip) && this.validationService.IsValid(this.model.Address)) {
    //  this.ShowDuplicates = true;
    //  let input = {
    //    PropertyId: this.model.Id,
    //    Address: this.model.Address,
    //    StateId: this.model.StateId,
    //    CityId: this.model.CityId,
    //    Zip: this.model.Zip,
    //  }
    //  this._propertyManagementService.GetDuplicatePropertyList(input).subscribe(response => {
    //    this.duplicatePropertyList = response;
    //    if (this.duplicatePropertyList.length > 0) {
    //      this.ShowDuplicates = true;
    //      this.duplicatesFound = true;
    //    }
    //    else {
    //      this.ShowDuplicates = false;
    //      this.duplicatesFound = false;
    //    }
    //  });
    //}
    //else {
    //  this.ShowDuplicates = false;
    //  this.duplicatesFound = false;
    //}
  }
  modalRefPrDuplicate: BsModalRef;
  selectedPropertyIdForDuplicates = 0;
  duplicatesFound = false;
  showDuplicates(template: TemplateRef<any>, classes: any, id) {
    this.ShowDuplicates = false;
    console.log(this.duplicatePropertyList);
    this.selectedPropertyIdForDuplicates = id;
    //this.modalRefPrDuplicate = this.modalService.show(template, { class: classes });
    this.modalRefPrDuplicate = this.modalService.show(template, { class: 'panlestyle' });
  }

  onStreetAddressChange() {
    const that = this;
    if (this.isInEditMode && !this.isInitialLoad) {
      this.model.CityId = null;
      this.model.StateId = null;
      this.model.Zip = '';
      const geocoder = new google.maps.Geocoder();

      const address = this.model.Address;
      geocoder.geocode({ 'address': address }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          const latitude = results[0].geometry.location.lat();
          const longitude = results[0].geometry.location.lng();
          that.setCenter(latitude, longitude, null);
        }
        else {
          that.setCenter(40.7127753, -74.0059728, null);
        }
      });

    }
  }


  checkZeroCashflow(e: Event) {

    if (e.srcElement["checked"]) {
      var data = this.portfolioSelectedProperties.filter(item => item.CharacteristicsId != 1);
      if (data.length > 0) {
        this.model.OnlyZCF = false;
        $('#checkboxZeroCashFlow').prop('checked', false);
        this._toastService.addToast({
          title: 'Non-Zero Cash Flow Property Exists',
          msg: `Remove Non-Zero Cash flow Property`,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'warning'
        });
      }
      else {
        this.capratetext = 'ZCF';
        this.disableCapRate = true;
        this.model.AutoCalcCapRate = false;
        this.model.CapRate = null;
        this.txtCapRate.reset('');
      }
    }
    else {
      this.capratetext = 'Cap Rate';
      this.disableCapRate = false;
      this.model.AutoCalcCapRate = true;
      this.reCalcRates(2, this.model.AutoCalcCapRate);
    }
  }


  brokerageBrokerInputModel = {} as IBrokerageBrokerInput;
  brokerageValid: boolean = false;
  brokerNameValid: boolean = false;
  brokerTitleValid: boolean = false;
  lastNameValid: boolean = false;
  user: any;
  emailValid: boolean = false;
  phoneValid: boolean = false;
  emailvalidation: string = '';
  phoneValidation: string = '';
  IsValid: boolean = false;
  disabledAddOrEditBtn: boolean = false;
  IsEditMode: boolean = false;
  FromBrokerageMaster = true;
  brokerageCreationResponseModel = {} as IBrokergaCreationalResponseModel;
  onBrokerInfoKeydown() {
    this.checkBrokerValidation();
  }
  checkBrokerValidation() {

    this.IsValid = true;
    if (this.validationService.IsinValid(this.brokerageBrokerInputModel.BrokerageId)) {
      this.brokerageValid = true;
      this.IsValid = false;
    }
    else if (this.brokerageBrokerInputModel.BrokerageId == 0) {
      this.brokerageValid = true;
      this.IsValid = false;
    }
    else {
      this.brokerageValid = false;
    }
    if (this.validationService.IsinValid(this.brokerageBrokerInputModel.BrokerName)) {
      this.brokerNameValid = true;
      this.IsValid = false;
    }
    else {
      this.brokerNameValid = false;
    }
    if (this.validationService.IsinValid(this.brokerageBrokerInputModel.LastName)) {
      this.lastNameValid = true;
      this.IsValid = false;
    }
    else {
      this.lastNameValid = false;
    }
    if (this.validationService.IsinValid(this.brokerageBrokerInputModel.Title)) {
      this.brokerTitleValid = true;
      this.IsValid = false;
    }
    else {
      this.brokerTitleValid = false;
    }
    if (this.validationService.IsinValid(this.brokerageBrokerInputModel.Email)) {
      this.emailValid = true;
      this.IsValid = false;
      this.emailvalidation = "";
    }
    else if ((this.validationService.isEmail(this.brokerageBrokerInputModel.Email) == false) && !this.validationService.IsinValid(this.brokerageBrokerInputModel.Email)) {
      this.emailValid = true;
      this.IsValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = false;
      this.emailvalidation = "";
    }


    if (this.validationService.IsinValid(this.brokerageBrokerInputModel.Phone)) {
      this.phoneValid = true;
      this.IsValid = false;
      this.phoneValidation = "";

    }
    else if (this.validationService.isPhoneNumber(this.brokerageBrokerInputModel.Phone) == false) {
      this.phoneValidation = "Invalid phone number";
      this.phoneValid = true;
      this.IsValid = false;

    }
    else {
      this.phoneValidation = "";
      this.phoneValid = false;
    }

  }

  addOrEditBroker() {
    this.checkBrokerValidation();
    this.brokerageBrokerInputModel.UserId = this.loggedUserDetails.Id;
    if (this.IsValid) {
      this.disabledAddOrEditBtn = true;
      this.brokerageBrokerInputModel.BrokerStatus = 101;
      this._brokerageManagerService.createBroker(this.brokerageBrokerInputModel).subscribe(response => {
        this.brokerageCreationResponseModel = response;
        this.brokerageBrokerInputModel.Id = response.Id;
        this.modalRef.hide();
        if (this.brokerageCreationResponseModel.Success == true) {
          this.brokerslist.push(this.brokerageBrokerInputModel);
          this._toastService.addToast({ title: 'Success', msg: "Broker Added Successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }

        else {
          this._toastService.addToast({ title: 'Error Occurred', msg: this.brokerageCreationResponseModel.FailureMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }

        this.disabledAddOrEditBtn = false;
      });
    }
    else {
    }
  }

  checkNewTenant(val: boolean) {
    this.model.IsNewTenant = val;
    if (val) {

      this.model.TenantId = null;
      this.model.TenantName = null;
    }
    else {
      this.model.TenantNameText = null;
    }
  }

  checkNewGuarantor(val: boolean) {
    this.model.IsNewGuarantor = val;
    if (val) {

      this.model.GuarantorId = null;
    }
    else {
      this.model.GuarantorName = null;
    }
  }

  approveTenantGuarantor() {
    this.loaderService.display(true);
    let input = {
      PropertyGuid: this.model.Guid,
      TenantName: this.model.TenantNameText,
      GuarantorName: this.model.GuarantorName
    }

    this._propertyManagementService.ModifyAndApproveTenantAndGuarantor(input).subscribe(response => {
      this._toastService.addToast({ title: 'Success', msg: "Tenant / Guarantor Approved Successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      this.IsPageLoaded = false;
      this.loadPropertyDetails(this.model.Guid);
    });
  }
  private draggedIndex: number;
  public draggedOverIndex: number;

  allowDrop($event, index): void {
    this.draggedOverIndex = index;
    $event.preventDefault();
  }

  onDragStart(index): void {
    this.draggedIndex = index;
  }

  onDrop($event, index): void {
    $event.preventDefault();
    const item = this.propertyImages[this.draggedIndex];
    this.propertyImages.splice(this.draggedIndex, 1);
    this.propertyImages.splice(index, 0, item);
    this.draggedIndex = -1;
    this.draggedOverIndex = -1;
  }

  UnpricedClick($event) {
    this.model.UnpricedText = 'Unpriced';
    this.model.CapRateText = 'Unpriced';
    this.model.Price = null;
    this.model.PricePSF = null;
    this.model.CapRate = null;
    this.txtCapRate.reset('');
    this.txtPricePSF.reset('');
    this.reCalcRates(1, this.model.AutoCalcPSF);

    if ($event.target.checked) {
      this.propForm.get('txtAskingPrice').clearValidators();
      this.propForm.get('txtAskingPrice').updateValueAndValidity();
      this.model.Unpriced = true;
    }
    else {
      this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator])
      this.propForm.get('txtAskingPrice').updateValueAndValidity();
      this.model.Unpriced = false;
    }
  }

  onPorpertyStatusChange(event) {

    if (event == 349 || event == 350) { //349 == bov, 350 == Pre-Marketing
      this.propForm.get('txtYearBuilt').clearValidators()
      this.propForm.get('txtYearBuilt').updateValueAndValidity();
      this.propForm.get('lstPropertyType').clearValidators()
      this.propForm.get('lstPropertyType').updateValueAndValidity();
      this.propForm.get('txtBuildingSF').clearValidators()
      this.propForm.get('txtBuildingSF').updateValueAndValidity();
      this.propForm.get('txtNOI').clearValidators()
      this.propForm.get('txtNOI').updateValueAndValidity();
      this.propForm.get('txtPSF').clearValidators()
      this.propForm.get('txtPSF').updateValueAndValidity();
      this.propForm.get('txtCommencement').clearValidators()
      this.propForm.get('txtCommencement').setValidators([minimumYearValidator(() => this.builtYear)])
      this.propForm.get('txtCommencement').updateValueAndValidity();
      this.propForm.get('txtExpiration').clearValidators()
      this.propForm.get('txtExpiration').setValidators([Validators.min(this.model.YearBuilt), minimumDateValidator(() => this.model.LeaseCommencementDate)])
      this.propForm.get('txtExpiration').updateValueAndValidity();
      this.propForm.get('lstLeaseStructure').clearValidators()
      this.propForm.get('lstLeaseStructure').updateValueAndValidity();
      this.propForm.get('lstOwnershipType').clearValidators()
      this.propForm.get('lstOwnershipType').updateValueAndValidity();
      this.propForm.get('txtAskingPrice').clearValidators()
      this.propForm.get('txtAskingPrice').updateValueAndValidity();
      this.propForm.get('txtAddress').clearValidators()
      this.propForm.get('txtAddress').updateValueAndValidity();
      this.propForm.get('lstCity').clearValidators()
      this.propForm.get('lstCity').updateValueAndValidity();
      this.propForm.get('lstState').clearValidators()
      this.propForm.get('lstState').updateValueAndValidity();
      this.propForm.get('txtNumberOfUnits').clearValidators()
      this.propForm.get('txtNumberOfUnits').updateValueAndValidity();
      this.propForm.get('txtZip').clearValidators()
      this.propForm.get('txtZip').updateValueAndValidity();

      if (!this.model.Unpriced) {
        this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator])
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      else {
        this.propForm.get('txtAskingPrice').clearValidators();
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }

    }
    else {
      //this.propForm.get('txtTenantName').setValidators([Validators.required, spaceOnlyValidator])
      //this.propForm.get('txtTenantName').updateValueAndValidity();
      this.propForm.get('txtAddress').setValidators([Validators.required, spaceOnlyValidator])
      this.propForm.get('txtAddress').updateValueAndValidity();
      this.propForm.get('lstState').setValidators([Validators.required])
      this.propForm.get('lstState').updateValueAndValidity();
      this.propForm.get('lstCity').setValidators([Validators.required])
      this.propForm.get('lstCity').updateValueAndValidity();
      this.propForm.get('txtZip').setValidators([Validators.required])
      this.propForm.get('txtZip').updateValueAndValidity();
      this.propForm.get('txtNumberOfUnits').setValidators([this.isPropertyForSale ? Validators.min(1) : defaultValidator])
      this.propForm.get('txtYearBuilt').setValidators([Validators.required, Validators.min(1850)])
      this.propForm.get('txtYearBuilt').updateValueAndValidity();
      this.propForm.get('lstPropertyType').setValidators([Validators.required])
      this.propForm.get('lstPropertyType').updateValueAndValidity();
      this.propForm.get('txtBuildingSF').setValidators([Validators.required, Validators.min(1)])
      this.propForm.get('txtBuildingSF').updateValueAndValidity();
      this.propForm.get('txtNOI').setValidators([Validators.required, Validators.min(0)])
      this.propForm.get('txtNOI').updateValueAndValidity();
      this.propForm.get('txtPSF').setValidators([this.isPropertyForSale ? Validators.required : defaultValidator, this.isPropertyForSale ? Validators.min(0) : defaultValidator])
      this.propForm.get('txtPSF').updateValueAndValidity();
      this.propForm.get('txtCommencement').setValidators([Validators.required, minimumYearValidator(() => this.builtYear)])
      this.propForm.get('txtCommencement').updateValueAndValidity();
      this.propForm.get('txtExpiration').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator, Validators.min(this.model.YearBuilt), minimumDateValidator(() => this.model.LeaseCommencementDate)])
      this.propForm.get('txtExpiration').updateValueAndValidity();
      this.propForm.get('lstLeaseStructure').setValidators([Validators.required])
      this.propForm.get('lstLeaseStructure').updateValueAndValidity();
      this.propForm.get('lstOwnershipType').setValidators([Validators.required])
      this.propForm.get('lstOwnershipType').updateValueAndValidity();
      this.propForm.get('txtOriginal').disable()
      this.propForm.get('txtOriginal').updateValueAndValidity();
      if (event == 351 && !this.isInitialLoad) {
        this.model.DateOnMarket = new Date();
      }

      if (!this.model.Unpriced) {
        this.propForm.get('txtAskingPrice').setValidators([this.model.PropertyStatusId != 6906 ? Validators.required : defaultValidator])
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
      else {
        this.propForm.get('txtAskingPrice').clearValidators();
        this.propForm.get('txtAskingPrice').updateValueAndValidity();
      }
    }
  }

  getnullableInput(fieldName) {
     let fieldStatus = false;
    if (fieldName == 'TenantNameText') {
      fieldStatus = ((!this.model.TenantNameText && this.isSubmitted && this.model.IsNewTenant) || (this.model.TenantNameText == ' ' && this.isSubmitted && this.model.IsNewTenant)) ? true : false;
    }
    else if (fieldName == 'TenantName') {
      fieldStatus = ((!this.model.TenantName && this.isSubmitted && !this.model.IsNewTenant) || (this.model.TenantName == ' ' && this.isSubmitted && !this.model.IsNewTenant)) ? true : false;
    }
    else if (fieldName == 'NoOfUnits' && ((this.txtNumberOfUnits.invalid && this.isSubmitted) || (this.txtNumberOfUnits.invalid && (this.txtNumberOfUnits.dirty || this.txtNumberOfUnits.touched)))) {
      fieldStatus = (this.txtNumberOfUnits.errors.required || this.txtNumberOfUnits.errors.min) ? true : false;
    }
    else if (fieldName == 'Address' && ((this.txtAddress.invalid && this.isSubmitted) || (this.txtAddress.invalid && (this.txtAddress.dirty || this.txtAddress.touched)))) {
      fieldStatus = (this.txtAddress.errors.required || this.txtAddress.errors.spaceOnly) ? true : false;
    }
    else if (fieldName == 'StateId' && ((this.lstState.invalid && this.isSubmitted) || (this.lstState.invalid && (this.lstState.dirty || this.lstState.touched)))) {
      fieldStatus = (this.lstState.errors.required) ? true : false;
    }
    else if (fieldName == 'StateId' && ((this.lstState.invalid && this.isSubmitted) || (this.lstState.invalid && (this.lstState.dirty || this.lstState.touched)))) {
      fieldStatus = (this.lstState.errors.required) ? true : false;
    }
    else if (fieldName == 'CityId' && ((this.lstCity.invalid && this.isSubmitted) || (this.lstCity.invalid && (this.lstCity.dirty || this.lstCity.touched)))) {
      fieldStatus = (this.lstCity.errors.required) ? true : false;
    }
    else if (fieldName == 'Zip' && ((this.txtZip.invalid && this.isSubmitted) || (this.txtZip.invalid && (this.txtZip.dirty || this.txtZip.touched)))) {
      fieldStatus = (this.txtZip.errors.required) ? true : false;
    }
    else if (fieldName == 'YearBuilt' && ((this.txtYearBuilt.invalid && this.isSubmitted) || (this.txtYearBuilt.invalid && (this.txtYearBuilt.dirty || this.txtYearBuilt.touched)))) {
      fieldStatus = (this.txtYearBuilt.errors.required || this.txtYearBuilt.errors.min || this.txtYearBuilt.errors.max) ? true : false;
    }
    else if (fieldName == 'Renovated' && ((this.txtRenovated.invalid && this.isSubmitted) || (this.txtRenovated.invalid && (this.txtRenovated.dirty || this.txtRenovated.touched)))) {
      fieldStatus = (this.txtRenovated.errors.minlength || ((this.model.Renovated.toString().length == 4) && (this.txtRenovated.errors.minValue)) || this.txtRenovated.errors.max) ? true : false;
    }
    else if (fieldName == 'PropertyTypeList' && (this.lstPropertyType.invalid && this.isSubmitted)) {
      fieldStatus = (this.lstPropertyType.errors.required) ? true : false;
    }
    else if (fieldName == 'PropertyTypeSubcategoryList' && (this.lstSubcatgeories.invalid && this.isSubmitted)) {
      fieldStatus = (this.lstSubcatgeories.errors.required) ? true : false;
    }
    else if (fieldName == 'BuildingSize' && ((this.txtBuildingSF.invalid && this.isSubmitted) || (this.txtBuildingSF.invalid && (this.txtBuildingSF.dirty || this.txtBuildingSF.touched)))) {
      fieldStatus = (this.txtBuildingSF.errors.required || this.txtBuildingSF.errors.min) ? true : false;
    }
    else if (fieldName == 'Land' && ((this.txtland.invalid && this.isSubmitted) || (this.txtland.invalid && (this.txtland.dirty || this.txtland.touched)))) {
      fieldStatus = (this.txtland.errors.required || this.txtland.errors.min) ? true : false;
    }
    else if (fieldName == 'LeaseStructureId' && ((this.lstLeaseStructure.invalid && this.isSubmitted) || (this.lstLeaseStructure.invalid && (this.lstLeaseStructure.dirty || this.lstLeaseStructure.touched)))) {
      fieldStatus = (this.lstLeaseStructure.errors.required) ? true : false;
    }
    else if (fieldName == 'OwnershipTypeId' && ((this.lstOwnershipType.invalid && this.isSubmitted) || (this.lstOwnershipType.invalid && (this.lstOwnershipType.dirty || this.lstOwnershipType.touched)))) {
      fieldStatus = (this.lstOwnershipType.errors.required) ? true : false;
    }
    else if (fieldName == 'NOI' && ((this.txtNOI.invalid && this.isSubmitted) || (this.txtNOI.invalid && (this.txtNOI.dirty || this.txtNOI.touched)))) {
      fieldStatus = (this.txtNOI.errors.required || this.txtNOI.errors.min) ? true : false;
    }
    else if (fieldName == 'LeaseCommencementDate' && ((this.txtCommencement.invalid && this.isSubmitted) || (this.txtCommencement.invalid && (this.txtCommencement.dirty || this.txtCommencement.touched)))) {
      fieldStatus = (this.txtCommencement.errors.required || this.txtCommencement.errors.minYear || this.txtCommencement.errors.maxDate || this.model.LeaseCommencementDate.toString() == 'Invalid Date') ? true : false;
    }
    else if (fieldName == 'LeaseExpiration' && ((this.txtExpiration.invalid && this.isSubmitted) || (this.txtExpiration.invalid && (this.txtExpiration.dirty || this.txtExpiration.touched)))) {
      fieldStatus = (this.txtExpiration.errors.required || this.txtExpiration.errors.minDate || this.model.LeaseExpiration.toString() == 'Invalid Date') ? true : false;
    }
    else if (fieldName == 'LeasePricePSF' && ((this.txtPSF.invalid && this.isSubmitted) || (this.txtPSF.invalid && (this.txtPSF.dirty || this.txtPSF.touched)))) {
      fieldStatus = (this.txtPSF.errors.required || this.txtPSF.errors.min) ? true : false;
    }
    else if (fieldName == 'OriginalLeaseTerm' && ((this.txtOriginal.invalid && this.isSubmitted) || (this.txtOriginal.invalid && (this.txtOriginal.dirty || this.txtOriginal.touched)))) {
      fieldStatus = (this.txtOriginal.errors.required || this.txtOriginal.errors.min) ? true : false;
    }
    else if (fieldName == 'RentEscalationPercentage' && ((this.txtEscalationPercentage.invalid && this.isSubmitted) || (this.txtEscalationPercentage.invalid && (this.txtEscalationPercentage.dirty || this.txtEscalationPercentage.touched)))) {
      fieldStatus = (this.txtEscalationPercentage.errors.max || this.txtEscalationPercentage.errors.min) ? true : false;
    }
    else if (fieldName == 'RentEscalationPeriod' && ((this.txtEscalationYrs.invalid && this.isSubmitted) || (this.txtEscalationYrs.invalid && (this.txtEscalationYrs.dirty || this.txtEscalationYrs.touched)))) {
      fieldStatus = (this.txtEscalationYrs.errors.min) ? true : false;
    }
    else if (fieldName == 'AcquisitionCapRate' && ((this.txtAcquisitionCapRate.invalid && this.isSubmitted) || (this.txtAcquisitionCapRate.invalid && (this.txtAcquisitionCapRate.dirty || this.txtAcquisitionCapRate.touched)))) {
      fieldStatus = (this.txtAcquisitionCapRate.errors.max || this.txtAcquisitionCapRate.errors.min) ? true : false;
    }
    else if (fieldName == 'AskingPrice' && ((this.txtAskingPrice.invalid && this.isSubmitted) || (this.txtAskingPrice.invalid && (this.txtAskingPrice.dirty || this.txtAskingPrice.touched)))) {
      fieldStatus = (this.txtAskingPrice.errors.required) ? true : false;
    }
    else if (fieldName == 'CapRate' && ((this.txtCapRate.invalid && this.isSubmitted) || (this.txtCapRate.invalid && (this.txtCapRate.dirty || this.txtCapRate.touched)))) {
      fieldStatus = (this.txtCapRate.errors.max || this.txtCapRate.errors.min) ? true : false;
    }
    else if (fieldName == 'InterestRate' && ((this.txtInterestRate.invalid && this.isSubmitted) || (this.txtInterestRate.invalid && (this.txtInterestRate.dirty || this.txtInterestRate.touched)))) {
      fieldStatus = (this.txtInterestRate.errors.max || this.txtInterestRate.errors.min) ? true : false;
    }
    else if (fieldName == 'OrginationDate' && ((this.txtOrginationDate.invalid && this.isSubmitted) || (this.txtOrginationDate.invalid && (this.txtOrginationDate.dirty || this.txtOrginationDate.touched)))) {
      fieldStatus = (this.model.OrginationDate.toString() == 'Invalid Date') ? true : false;
    }
    else if (fieldName == 'MaturityDate' && ((this.txtMaturityDate.invalid && this.isSubmitted) || (this.txtMaturityDate.invalid && (this.txtMaturityDate.dirty || this.txtMaturityDate.touched)))) {
      fieldStatus = (this.model.MaturityDate.toString() == 'Invalid Date') ? true : false;
    }
    else if (fieldName == 'VideoUrl' && ((this.txtVideoUrl.invalid && this.isSubmitted) || (this.txtVideoUrl.invalid && (this.txtVideoUrl.dirty || this.txtVideoUrl.touched)))) {
      fieldStatus = (this.txtVideoUrl.errors.vimeoUrl) ? true : false;
    }
    else {
      fieldStatus = false;
    }
    return fieldStatus;
  }
}


